[
  {
    "key": "txt_Youraccou_259",
    "text": "Your account is registered on the <strong>{{0}}</strong> data center. Please log in here: <a class=\"btn text-exp\" href=\"{{1}}\" target=\"_blank\">{{2}}</a>",
    "translations": [
      {
        "language": "AR",
        "text": "تم تسجيل حسابك في مركز البيانات <strong>{{0}}</strong>. يُرجى تسجيل الدخول من هنا: <a class=\"btn text-exp\" href=\"{{1}}\" target=\"_blank\">{{2}}</a>"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_demo_account_expired",
    "text": "This demo account has expired. Please contact your administrator.",
    "translations": [
      {
        "language": "AR",
        "text": "انتهت صلاحية هذا الحساب التجريبي. يرجى التواصل مع المسؤول."
      },
      {
        "language": "FR",
        "text": "Ce compte de démonstration a expiré. Veuillez contacter votre administrateur."
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Dieses Demokonto ist abgelaufen. Bitte wenden Sie sich an Ihren Administrator."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Questo account demo è scaduto. Contatta l'amministratore."
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_demo_account_expired_title",
    "text": "Demo Account Expired",
    "translations": [
      {
        "language": "AR",
        "text": "انتهت صلاحية الحساب التجريبي"
      },
      {
        "language": "FR",
        "text": "Compte de démonstration expiré"
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Demokonto abgelaufen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Account demo scaduto"
      },
      {
        "language": "CS",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Technical_assessments",
    "text": "Technical Assessments",
    "translations": [
      {
        "language": "AR",
        "text": "التقييمات التقنية"
      }
    ]
  },
  {
    "key": "txt_General_180",
    "text": "General",
    "translations": [
      {
        "language": "EN",
        "text": "General"
      },
      {
        "language": "AR",
        "text": "معلومات عامة "
      }
    ]
  },
  {
    "key": "TEXTAREA",
    "text": "TEXTAREA",
    "translations": [
      {
        "language": "AR",
        "text": "حقل نص"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "NUMBER",
    "text": "NUMBER",
    "translations": [
      {
        "language": "AR",
        "text": "حقل رقم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "DATE",
    "text": "DATE",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "TEXT",
    "text": "TEXT",
    "translations": [
      {
        "language": "AR",
        "text": "نص"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "DROPDOWN",
    "text": "DROPDOWN",
    "translations": [
      {
        "language": "AR",
        "text": "منسدلة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAiReadiness",
    "text": "AI Readiness",
    "translations": [
      {
        "language": "AR",
        "text": "جاهزية الذكاء الاصطناعي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_import",
    "text": "Import",
    "translations": [
      {
        "language": "AR",
        "text": "استيراد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Import"
      },
      {
        "language": "ES",
        "text": "Importar"
      },
      {
        "language": "PT",
        "text": "Importar"
      },
      {
        "language": "EN",
        "text": "Import"
      },
      {
        "language": "IT",
        "text": "Importa"
      },
      {
        "language": "CS",
        "text": ""
      },
      {
        "language": "RO",
        "text": ""
      }
    ]
  },
  {
    "key": "txtCulture",
    "text": "Culture Assessment",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم ثقافة وبيئة العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txtEmailRequired",
    "text": "Email Required",
    "translations": [
      {
        "language": "AR",
        "text": "الإيميل الإلكتروني مطلوب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_NewEmail_444",
    "text": "New Email",
    "translations": [
      {
        "language": "AR",
        "text": "إيميل جديد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_CurrentEm_318",
    "text": "Current Email",
    "translations": [
      {
        "language": "AR",
        "text": ""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txtChangeEmail",
    "text": "Change Email",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ElevatePe_893",
    "text": "Elevate Permission",
    "translations": [
      {
        "language": "AR",
        "text": "Elevate أذونات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "action_planning",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_UserRole_696",
    "text": "User Role",
    "translations": [
      {
        "language": "AR",
        "text": "دور المستخدم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "SUB_User",
    "text": "Manage products within assigned categories.",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة الحلول ضمن الفئات المخصصة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "User",
    "text": "Admin",
    "translations": [
      {
        "language": "AR",
        "text": "مسؤول"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "SUB_Owner",
    "text": "Access only to their own products.",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول فقط إلى الحلول الخاصة بهم."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "SUB_Admin",
    "text": "Manage products within assigned categories.",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة الحلول ضمن الفئات المخصصة."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "SUB_Super Admin",
    "text": "Full access to all products and settings.",
    "translations": [
      {
        "language": "AR",
        "text": "وصول كامل إلى جميع الحلول والإعدادات."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "Owner",
    "text": "Owner",
    "translations": [
      {
        "language": "AR",
        "text": "مسؤول/مالك"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "Admin",
    "text": "Admin",
    "translations": [
      {
        "language": "AR",
        "text": "مسؤول"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "Super Admin",
    "text": "Super Admin",
    "translations": [
      {
        "language": "AR",
        "text": "مسؤول متميز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_SuperAdmi_565",
    "text": "Super Admin",
    "translations": [
      {
        "language": "AR",
        "text": "مسؤول متميز"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Thispassw_546",
    "text": "This password will be shared with the user’s email once the account is created",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم مشاركة كلمة المرور مع البريد الإلكتروني للمستخدم بمجرد إنشاء الحساب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_AccessDen_680",
    "text": "Access Denied: You do not have permission to use this product.",
    "translations": [
      {
        "language": "AR",
        "text": "الدخول مرفوض: ليس لديك صلاحية لاستخدام هذا المنتج."
      },
      {
        "language": "FR",
        "text": "Accès refusé : Vous n'avez pas la permission d'utiliser ce produit."
      },
      {
        "language": "PL",
        "text": "Dostęp zabroniony: Nie masz uprawnień do korzystania z tego produktu."
      },
      {
        "language": "NL",
        "text": "Toegang geweigerd: U heeft geen toestemming om dit product te gebruiken."
      },
      {
        "language": "DE",
        "text": "Zugriff verweigert: Sie haben keine Berechtigung, dieses Produkt zu verwenden."
      },
      {
        "language": "ES",
        "text": "Acceso denegado: No tiene permiso para usar este producto."
      },
      {
        "language": "PT",
        "text": "Acesso negado: Você não tem permissão para usar este produto."
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BacktoSur_741",
    "text": "Back to Surveys",
    "translations": [
      {
        "language": "AR",
        "text": "الرجوع إلى الاستبيانات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": ""
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txtwelcomedesc_thomas",
    "text": "Log in to Thomas Assess Accredited+ to continue",
    "translations": [
      {
        "language": "AR",
        "text": "سجّل الدخول إلى منصة Thomas Assess Accredited+ للمتابعة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Melden Sie sich bei Thomas Assess Accredited+ an, um fortzufahren"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Accedi a Thomas Assess Accredited+ per continuare"
      }
    ]
  },
  {
    "key": "txtPendingUnits",
    "text": "Pending Units",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات المعلّقة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "offene Units"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Unità in sospeso"
      }
    ]
  },
  {
    "key": "txt_elevate_settings",
    "text": "ELEVATE SETTINGS\t",
    "translations": [
      {
        "language": "AR",
        "text": "إعدادات ELEVATE"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Erweiterte Einstellung"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "IMPOSTAZIONI ASSESS ACCREDITED+"
      }
    ]
  },
  {
    "key": "respondentPool",
    "text": "Respondent Pool",
    "translations": [
      {
        "language": "AR",
        "text": "مجموعة المستجيبون"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Teilnehmerpool"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Pool di rispondenti"
      }
    ]
  },
  {
    "key": "txt_sort_desc",
    "text": "The analysis output will follow the same options order set here",
    "translations": [
      {
        "language": "AR",
        "text": "ستتبع مخرجات التحليل نفس ترتيب الخيارات المُحددة هنا"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Die Analyseausgabe folgt der gleichen Optionsreihenfolge, die hier festgelegt wurde"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "L'output dell'analisi seguirà lo stesso ordine delle opzioni impostate qui"
      }
    ]
  },
  {
    "key": "txt_delete_criteria",
    "text": "Are you sure you want to delete this criteria?\t",
    "translations": [
      {
        "language": "AR",
        "text": "\"هل أنت متأكد أنك تريد حذف هذا المعيار؟\""
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": " Möchten Sie dieses Kriterium wirklich löschen?"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo criterio?"
      }
    ]
  },
  {
    "key": "txt_required",
    "text": "Required",
    "translations": [
      {
        "language": "AR",
        "text": "إلزامي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Erforderlich"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Obbligatorio"
      }
    ]
  },
  {
    "key": "txt_optional",
    "text": "Optional",
    "translations": [
      {
        "language": "AR",
        "text": "اختياري"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Optional"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Opzionale"
      }
    ]
  },
  {
    "key": "txt_joiningDate",
    "text": "Joining Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Eintrittsdatum"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Data di assunzione"
      }
    ]
  },
  {
    "key": "txtDateofBirth",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الميلاد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Geburtsdatum"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Data di nascita"
      }
    ]
  },
  {
    "key": "txtJobTitle",
    "text": "Job Title",
    "translations": [
      {
        "language": "AR",
        "text": "المسمّى الوظيفي"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Berufsbezeichnung"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Qualifica"
      }
    ]
  },
  {
    "key": "txt_gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Geschlecht"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Genere"
      }
    ]
  },
  {
    "key": "txtNationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Nationalität"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Nazionalità"
      }
    ]
  },
  {
    "key": "txt_extrametrics",
    "text": "Other Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير أخرى"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Weitere Kriterien"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Altri criteri"
      }
    ]
  },
  {
    "key": "txt_hrmetrics",
    "text": "HR Metrics",
    "translations": [
      {
        "language": "AR",
        "text": "مقاييس الموارد البشرية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "HR-Kennzahlen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Metriche HR"
      }
    ]
  },
  {
    "key": "txt_demographics",
    "text": "Demographics",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الديموغرافية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Demografie"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Dati demografici"
      }
    ]
  },
  {
    "key": "txt_select_category",
    "text": "Select Category",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المجموعة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kategorie auswählen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Seleziona la Categoria"
      }
    ]
  },
  {
    "key": "txt_select_product",
    "text": "Select Product",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الأداة المطلوبة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Produkt auswählen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Seleziona il Prodotto"
      }
    ]
  },
  {
    "key": "txt_criteria_management",
    "text": "Criteria Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة الخصائص "
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kriterienmanagement"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Gestione dei criteri"
      }
    ]
  },
  {
    "key": "txt_CreateCri_531",
    "text": "Create Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء معيار جديد"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kriterien erstellen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Crea i criteri"
      }
    ]
  },
  {
    "key": "txt_edit_criteria",
    "text": "Edit Criterion",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المعيار"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kriterium bearbeiten"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Modifica il criterio"
      }
    ]
  },
  {
    "key": "txt_addoption_placeholder",
    "text": "Type option value here...",
    "translations": [
      {
        "language": "AR",
        "text": "اكتب قيمة الخيار هنا..."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Geben Sie hier den Optionswert ein ..."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Inserisci qui il valore dell'opzione..."
      }
    ]
  },
  {
    "key": "txt_SaveChang_623",
    "text": "Save Changes",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ التغييرات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Änderungen speichern"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Salva le modifiche"
      }
    ]
  },
  {
    "key": "txt_AddOption_346",
    "text": "Add Option",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة خيار"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Option hinzufügen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Aggiungi un'opzione"
      }
    ]
  },
  {
    "key": "txt_options_desc",
    "text": "Options will appear here.",
    "translations": [
      {
        "language": "AR",
        "text": "سوف تظهر الخيارات هنا."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Hier werden Optionen angezeigt."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Le opzioni appariranno qui."
      }
    ]
  },
  {
    "key": "txt_Options_428",
    "text": "Options",
    "translations": [
      {
        "language": "AR",
        "text": "الخيارات"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Optionen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Opzioni"
      }
    ]
  },
  {
    "key": "txt_Criterion_143",
    "text": "Criteria Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان المعيار"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kriterien Titel"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Titolo del criterio"
      }
    ]
  },
  {
    "key": "txt_ShowValue_921",
    "text": "Show Values",
    "translations": [
      {
        "language": "AR",
        "text": "أظهر القيم"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Werte anzeigen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Mostra i valori"
      }
    ]
  },
  {
    "key": "btn_delete_criteria",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Löschen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Elimina"
      }
    ]
  },
  {
    "key": "btn_edit_criteria",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Modifica"
      }
    ]
  },
  {
    "key": "txt_Dismiss_693",
    "text": "Dismiss",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Verwerfen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Ignora"
      }
    ]
  },
  {
    "key": "txt_CriteriaN_578",
    "text": "Criteria Name",
    "translations": [
      {
        "language": "AR",
        "text": "إسم الخاصية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kriterienname"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Nome del criterio"
      }
    ]
  },
  {
    "key": "txt_new_criteria",
    "text": "New Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "خاصية جديدة"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Neue Kriterien"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Nuovo criterio"
      }
    ]
  },
  {
    "key": "reset_password_failed",
    "text": "Reset password token is invalid or has expired",
    "translations": [
      {
        "language": "AR",
        "text": "رابط إعادة تعيين كلمة المرور غير صالح أو انتهت صلاحيته"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Das Token zum Zurücksetzen des Passworts ist ungültig oder abgelaufen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Il link per reimpostare la password non è valido o è scaduto"
      }
    ]
  },
  {
    "key": "reset_password_success",
    "text": "Your password has been reset.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تغيير كلمة المرور بنجاح."
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Ihr Passwort wurde zurückgesetzt."
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "La tua password è stata reimpostata."
      }
    ]
  },
  {
    "key": "txtPasswordShouldBeMin",
    "text": "Password should be minimum 8 characters",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Das Passwort muss mindestens 8 Zeichen lang sein"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "La password deve contenere almeno 8 caratteri"
      }
    ]
  },
  {
    "key": "txtPasswordsAreNotSimilar",
    "text": "Password and confirmed password are not the same",
    "translations": [
      {
        "language": "AR",
        "text": "كلمة المرور وتأكيدها غير متطابقين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Passwort und bestätigtes Passwort sind nicht identisch"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "La password e la conferma password non coincidono"
      }
    ]
  },
  {
    "key": "txtTypeAStrongPasswrod",
    "text": "type a strong password",
    "translations": [
      {
        "language": "AR",
        "text": "أدخل كلمة مرور قوية"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Geben Sie ein sicheres Passwort ein"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Inserisci una password forte"
      }
    ]
  },
  {
    "key": "txtConfirmPassword",
    "text": "Confirm Password",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد كلمة المرور"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Passwort bestätigen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Conferma la password"
      }
    ]
  },
  {
    "key": "txtReset",
    "text": "Reset",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تعيين"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Zurücksetzen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Reimposta"
      }
    ]
  },
  {
    "key": "txtMinLength",
    "text": "Min Length Required",
    "translations": [
      {
        "language": "AR",
        "text": "الحد الأدنى للنص مطلوب"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Erforderliche Mindestlänge"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Lunghezza minima richiesta"
      }
    ]
  },
  {
    "key": "txtPasswordChangedFailed",
    "text": "Password Change Failed",
    "translations": [
      {
        "language": "AR",
        "text": "فشل تغيير كلمة المرور"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kennwortänderung fehlgeschlagen"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Errore nella modifica della password"
      }
    ]
  },
  {
    "key": "txtPasswordChangedSuccess",
    "text": "Password Changed Successfully",
    "translations": [
      {
        "language": "AR",
        "text": "تم تغيير كلمة المرور بنجاح"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Passwort erfolgreich geändert"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Password modificata con successo"
      }
    ]
  },
  {
    "key": "txtChangePassword",
    "text": "Change Password",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير كلمة المرور"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kennwort ändern"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Cambia la password"
      }
    ]
  },
  {
    "key": "txtChangePasswordformInvalid",
    "text": "Please fill all the form details",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى ملء كافة تفاصيل النموذج"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Bitte füllen Sie alle Formulardetails aus"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Compila tutti i campi del modulo"
      }
    ]
  },
  {
    "key": "txtChangePasswordTitle",
    "text": "Change Password",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير كلمة المرور"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kennwort ändern"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Cambia la password"
      }
    ]
  },
  {
    "key": "txtBtnChangePassword",
    "text": "Change Password",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير كلمة المرور"
      },
      {
        "language": "FR",
        "text": ""
      },
      {
        "language": "PL",
        "text": ""
      },
      {
        "language": "NL",
        "text": ""
      },
      {
        "language": "DE",
        "text": "Kennwort ändern"
      },
      {
        "language": "ES",
        "text": ""
      },
      {
        "language": "PT",
        "text": ""
      },
      {
        "language": "IT",
        "text": "Cambia la password"
      }
    ]
  },
  {
    "key": "txt_2FAisnote_448",
    "text": "2FA is not enabled.",
    "translations": [
      {
        "language": "AR",
        "text": " غير مفعل(2FA)"
      },
      {
        "language": "DE",
        "text": "2FA ist nicht aktiviert."
      },
      {
        "language": "IT",
        "text": "L'autenticazione a due fattori (2FA) non è abilitata."
      }
    ]
  },
  {
    "key": "txt_verify2fa",
    "text": "Verify 2FA",
    "translations": [
      {
        "language": "AR",
        "text": "تحقق من 2FA"
      },
      {
        "language": "DE",
        "text": "2FA verifizieren"
      },
      {
        "language": "IT",
        "text": "Autenticazione a 2 fattori (2FA)"
      }
    ]
  },
  {
    "key": "txt_Noregiste_697",
    "text": "No registered phone number found for 2FA.",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على رقم هاتف مسجّل ل 2FA."
      },
      {
        "language": "DE",
        "text": "Für 2FA wurde keine registrierte Telefonnummer gefunden."
      },
      {
        "language": "IT",
        "text": "Nessun numero di telefono registrato per la verifica a 2 fattori (2FA)."
      }
    ]
  },
  {
    "key": "txt_Unabletop_848",
    "text": "Unable to proceed with 2FA.",
    "translations": [
      {
        "language": "AR",
        "text": "يتعذّر المتابعة باستخدام 2FA."
      },
      {
        "language": "DE",
        "text": "2FA kann nicht fortgesetzt werden."
      },
      {
        "language": "IT",
        "text": "Impossibile procedere con l'autenticazione a 2 fattori (2FA)."
      }
    ]
  },
  {
    "key": "txt_InvalidOT_672",
    "text": "Invalid OTP format",
    "translations": [
      {
        "language": "AR",
        "text": "صيغة رمز التحقق لمرة واحدة غير صحيحة."
      },
      {
        "language": "DE",
        "text": "Ungültiges OTP-Format"
      },
      {
        "language": "IT",
        "text": "Formato OTP non valido"
      }
    ]
  },
  {
    "key": "txt_Invalidph_627",
    "text": "Invalid phone number format. Please use international format (+XXX...)",
    "translations": [
      {
        "language": "AR",
        "text": "صيغة رقم الهاتف غير صحيحة. يُرجى استخدام الصيغة الدولية (+XXX...)."
      },
      {
        "language": "DE",
        "text": "Ungültiges Telefonnummernformat. Bitte verwenden Sie das internationale Format (+XXX...)"
      },
      {
        "language": "IT",
        "text": "Formato del numero di telefono non valido. Usa il formato internazionale (+XXX...)"
      }
    ]
  },
  {
    "key": "txt_Pleasever_360",
    "text": "Please verify your email first. Verification email sent.",
    "translations": [
      {
        "language": "AR",
        "text": "يُرجى التحقق من بريدك الإلكتروني أولاً. تم إرسال رسالة التحقق."
      },
      {
        "language": "DE",
        "text": "Bitte bestätigen Sie zuerst Ihre E-Mail. Bestätigungs-E-Mail gesendet."
      },
      {
        "language": "IT",
        "text": "Verifica prima la tua email. Email di verifica inviata."
      }
    ]
  },
  {
    "key": "txt_Noauthent_577",
    "text": "No authenticated user found",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على مستخدم مصادق عليه."
      },
      {
        "language": "DE",
        "text": "Kein authentifizierter Benutzer gefunden"
      },
      {
        "language": "IT",
        "text": "Nessun utente autenticato trovato"
      }
    ]
  },
  {
    "key": "txt_Gotit_339",
    "text": "Got it",
    "translations": [
      {
        "language": "AR",
        "text": "تمّ."
      },
      {
        "language": "DE",
        "text": "Verstanden"
      },
      {
        "language": "IT",
        "text": "Capito"
      }
    ]
  },
  {
    "key": "txt_2fadisable_desc",
    "text": "You won’t be asked to verify your phone number the next time you log in.",
    "translations": [
      {
        "language": "AR",
        "text": "لن يُطلب منك التحقق من رقم هاتفك في المرة القادمة التي تسجّل فيها الدخول."
      },
      {
        "language": "DE",
        "text": "Bei der nächsten Anmeldung werden Sie nicht aufgefordert, Ihre Telefonnummer zu bestätigen."
      },
      {
        "language": "IT",
        "text": "Non ti verrà chiesto di verificare il numero di telefono al prossimo accesso."
      }
    ]
  },
  {
    "key": "txt_disabled_141",
    "text": "disabled",
    "translations": [
      {
        "language": "AR",
        "text": "معطّل"
      },
      {
        "language": "DE",
        "text": "deaktiviert"
      },
      {
        "language": "IT",
        "text": "disabilitato"
      }
    ]
  },
  {
    "key": "txt_Todisable_556",
    "text": "To disable 2FA, we’ve sent a verification code to your number",
    "translations": [
      {
        "language": "AR",
        "text": "لتعطيل 2FA، أرسلنا رمز تحقق إلى رقمك."
      },
      {
        "language": "DE",
        "text": "Um 2FA zu deaktivieren, haben wir einen Bestätigungscode an Ihre Nummer gesendet"
      },
      {
        "language": "IT",
        "text": "Per disabilitare l'autenticazione a due fattori (2FA), abbiamo inviato un codice di verifica al tuo numero"
      }
    ]
  },
  {
    "key": "txt_disable2fa",
    "text": "Disable 2FA",
    "translations": [
      {
        "language": "AR",
        "text": "تعطيل 2FA"
      },
      {
        "language": "DE",
        "text": "2FA deaktivieren"
      },
      {
        "language": "IT",
        "text": "Disabilita l'autenticazione a due fattori (2FA)"
      }
    ]
  },
  {
    "key": "txt_2faenable_desc",
    "text": "You'll be asked for both your password and a unique code sent to your phone number to log in.",
    "translations": [
      {
        "language": "AR",
        "text": "سيُطلب منك إدخال كلمة المرور ورمز فريد يُرسل إلى رقم هاتفك لتسجيل الدخول."
      },
      {
        "language": "DE",
        "text": "Zur Anmeldung werden Sie nach Ihrem Passwort und einem einmaligen Code gefragt, der an Ihre Telefonnummer gesendet wird."
      },
      {
        "language": "IT",
        "text": "Ti verrà richiesta sia la password che un codice univoco inviato al tuo telefono per accedere."
      }
    ]
  },
  {
    "key": "txt_enabled_452",
    "text": "enabled",
    "translations": [
      {
        "language": "AR",
        "text": "مفعّل"
      },
      {
        "language": "DE",
        "text": "eingerichtet"
      },
      {
        "language": "IT",
        "text": "abilitato"
      }
    ]
  },
  {
    "key": "txt_2FAhasbee_559",
    "text": "2FA has been ",
    "translations": [
      {
        "language": "AR",
        "text": "تم تفعيل 2FA"
      },
      {
        "language": "DE",
        "text": " 2FA wurde"
      },
      {
        "language": "IT",
        "text": "L'autenticazione a due fattori (2FA) è stata "
      }
    ]
  },
  {
    "key": "txt_verify",
    "text": "Verify",
    "translations": [
      {
        "language": "AR",
        "text": "تحقق"
      },
      {
        "language": "DE",
        "text": "Verifizieren"
      },
      {
        "language": "IT",
        "text": "Verifica"
      }
    ]
  },
  {
    "key": "txt_Wesentave_239",
    "text": "We sent a verification code to your number ",
    "translations": [
      {
        "language": "AR",
        "text": "أرسلنا رمز تحقق إلى رقمك."
      },
      {
        "language": "DE",
        "text": " Wir haben einen Bestätigungscode an Ihre Nummer gesendet"
      },
      {
        "language": "IT",
        "text": "Abbiamo inviato un codice di verifica al tuo numero "
      }
    ]
  },
  {
    "key": "txt_verifyphonenumber",
    "text": "Verify Phone Number",
    "translations": [
      {
        "language": "AR",
        "text": "تحقق من رقم الهاتف"
      },
      {
        "language": "DE",
        "text": "Telefonnummer bestätigen"
      },
      {
        "language": "IT",
        "text": "Verifica il numero di telefono"
      }
    ]
  },
  {
    "key": "txt_sendcode",
    "text": "Send Code",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الرمز"
      },
      {
        "language": "DE",
        "text": "Code senden"
      },
      {
        "language": "IT",
        "text": "Invia il codice"
      }
    ]
  },
  {
    "key": "txtphonenumber",
    "text": "Phone Number",
    "translations": [
      {
        "language": "AR",
        "text": "رقم الهاتف"
      },
      {
        "language": "DE",
        "text": "Telefonnummer"
      },
      {
        "language": "IT",
        "text": "Numero di telefono"
      }
    ]
  },
  {
    "key": "txt_Toenable2_328",
    "text": "To enable 2FA, we will send a verification code the number below:",
    "translations": [
      {
        "language": "AR",
        "text": "لتمكين 2FA، سنرسل رمز تحقق إلى الرقم أدناه:"
      },
      {
        "language": "DE",
        "text": "Um 2FA zu aktivieren, senden wir Ihnen einen Bestätigungscode mit der folgenden Nummer:"
      },
      {
        "language": "IT",
        "text": "Per abilitare l'autenticazione a due fattori (2FA), invieremo un codice di verifica al numero indicato qui sotto:"
      }
    ]
  },
  {
    "key": "txt_enterphonenumber",
    "text": "Enter Phone Number",
    "translations": [
      {
        "language": "AR",
        "text": "أدخل رقم الهاتف"
      },
      {
        "language": "DE",
        "text": "Telefonnummer eingeben"
      },
      {
        "language": "IT",
        "text": "Inserisci il numero di telefono"
      }
    ]
  },
  {
    "key": "txt_enable2fa",
    "text": "Enable 2FA",
    "translations": [
      {
        "language": "AR",
        "text": "تفعيل التحقق بخطوتين"
      },
      {
        "language": "DE",
        "text": "2FA aktivieren"
      },
      {
        "language": "IT",
        "text": "Abilita l'autenticazione a due fattori (2FA)"
      }
    ]
  },
  {
    "key": "txt_By_784",
    "text": "By",
    "translations": [
      {
        "language": "AR",
        "text": "بواسطة"
      },
      {
        "language": "DE",
        "text": "Von"
      },
      {
        "language": "IT",
        "text": "Di"
      }
    ]
  },
  {
    "key": "txt360180_Feedback",
    "text": "360° / 180° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360/°180"
      },
      {
        "language": "DE",
        "text": "360° / 180° Feedback"
      },
      {
        "language": "IT",
        "text": "Feedback 360°/180°"
      }
    ]
  },
  {
    "key": "txt_Psychomet_310",
    "text": "Psychometric Assessments",
    "translations": [
      {
        "language": "AR",
        "text": "التقييمات السيكومترية "
      },
      {
        "language": "DE",
        "text": "Psychometrische Beurteilungen"
      },
      {
        "language": "IT",
        "text": "Assessment psicometrici"
      }
    ]
  },
  {
    "key": "txtZenithrElevate",
    "text": "Zenithr Elevate",
    "translations": [
      {
        "language": "AR",
        "text": "Zenithr Elevate"
      },
      {
        "language": "DE",
        "text": "Zenithr Elevate"
      },
      {
        "language": "IT",
        "text": "Zenithr Elevate"
      }
    ]
  },
  {
    "key": "txt_hide",
    "text": "Hide",
    "translations": [
      {
        "language": "AR",
        "text": "إخفاء"
      },
      {
        "language": "DE",
        "text": "Verstecken"
      },
      {
        "language": "IT",
        "text": "Nascondi"
      }
    ]
  },
  {
    "key": "txt_show",
    "text": "Show",
    "translations": [
      {
        "language": "AR",
        "text": "عرض"
      },
      {
        "language": "DE",
        "text": "Zeigen"
      },
      {
        "language": "IT",
        "text": "Mostra"
      }
    ]
  },
  {
    "key": "txt_heatmap_original",
    "text": "original values",
    "translations": [
      {
        "language": "AR",
        "text": "القيم الأصلية"
      },
      {
        "language": "DE",
        "text": "Originalwerte"
      },
      {
        "language": "IT",
        "text": "valori originali"
      }
    ]
  },
  {
    "key": "txt_company_type",
    "text": "Organization Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع المؤسسة"
      },
      {
        "language": "DE",
        "text": "Organisationstyp"
      },
      {
        "language": "IT",
        "text": "Tipo di organizzazione"
      }
    ]
  },
  {
    "key": "PSYCHOMETRIC",
    "text": "Psychometric",
    "translations": [
      {
        "language": "AR",
        "text": "السيكومترية"
      },
      {
        "language": "DE",
        "text": "Psychometrisch"
      },
      {
        "language": "IT",
        "text": "Psicometrico"
      }
    ]
  },
  {
    "key": "Wellbeing",
    "text": "Employee Well - Being",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية الموظف"
      },
      {
        "language": "DE",
        "text": "Wohlbefinden der Mitarbeiter"
      },
      {
        "language": "IT",
        "text": "Benessere dei dipendenti"
      }
    ]
  },
  {
    "key": "ONBOARDING",
    "text": "Employee Onboarding",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد وتهيئة الموظفين"
      },
      {
        "language": "DE",
        "text": "Mitarbeiter-Onboarding"
      },
      {
        "language": "IT",
        "text": "Onboarding dei dipendenti"
      }
    ]
  },
  {
    "key": "txtImageSize",
    "text": "Image size is over #size  MB!",
    "translations": [
      {
        "language": "AR",
        "text": "حجم الصورة أكبر من #size MB!"
      },
      {
        "language": "DE",
        "text": "Die Bildgröße überschreitet #size MB!"
      },
      {
        "language": "IT",
        "text": "La dimensione dell'immagine supera #size MB!"
      }
    ]
  },
  {
    "key": "txt_dont_show",
    "text": "Don't show again.",
    "translations": [
      {
        "language": "AR",
        "text": "لا تظهر مرة أخرى."
      },
      {
        "language": "DE",
        "text": "Nicht mehr anzeigen."
      },
      {
        "language": "IT",
        "text": "Non mostrare più."
      }
    ]
  },
  {
    "key": "txtSurveyx",
    "text": "Survey X",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان X "
      },
      {
        "language": "DE",
        "text": "Umfrage X"
      },
      {
        "language": "IT",
        "text": "Survey X"
      }
    ]
  },
  {
    "key": "Apply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      },
      {
        "language": "DE",
        "text": "Anwenden"
      },
      {
        "language": "IT",
        "text": "Applica"
      }
    ]
  },
  {
    "key": "Reset",
    "text": "Reset",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة ضبط "
      },
      {
        "language": "DE",
        "text": "Zurücksetzen"
      },
      {
        "language": "IT",
        "text": "Reimposta"
      }
    ]
  },
  {
    "key": "txt_Filters_432",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      },
      {
        "language": "DE",
        "text": "Filter"
      },
      {
        "language": "IT",
        "text": "Filtri"
      }
    ]
  },
  {
    "key": "txt_ResetFilt_877",
    "text": "Reset Filters",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة ضبط الفرز"
      },
      {
        "language": "DE",
        "text": "Filter zurücksetzen"
      },
      {
        "language": "IT",
        "text": "Reimposta i filtri"
      }
    ]
  },
  {
    "key": "txt_AddFilter_176",
    "text": "Add Filter",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تصفية"
      },
      {
        "language": "DE",
        "text": "Filter hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi un filtro"
      }
    ]
  },
  {
    "key": "txt_DELETED",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعال"
      },
      {
        "language": "DE",
        "text": "Inaktiv"
      },
      {
        "language": "IT",
        "text": "Inattivo"
      }
    ]
  },
  {
    "key": "txt_Assessmen_170",
    "text": "Assessment Reminder will be sent",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إرسال تذكير التقييم"
      },
      {
        "language": "DE",
        "text": "Es wird eine Bewertungserinnerung gesendet"
      },
      {
        "language": "IT",
        "text": "Verrà inviato un promemoria per la compilazione dell'Assessment"
      }
    ]
  },
  {
    "key": "txt_INPROGRESS",
    "text": "In-Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "DE",
        "text": "Im Gange"
      },
      {
        "language": "IT",
        "text": "In corso"
      }
    ]
  },
  {
    "key": "txt_STARTED",
    "text": "In-Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "DE",
        "text": "Im Gange"
      },
      {
        "language": "IT",
        "text": "In corso"
      }
    ]
  },
  {
    "key": "txtOverallBalance",
    "text": "Overall Balance",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد الإجمالي"
      },
      {
        "language": "DE",
        "text": "Gesamtbilanz"
      },
      {
        "language": "IT",
        "text": "Saldo complessivo"
      }
    ]
  },
  {
    "key": "txtWellbeing",
    "text": "Employee Well-Being",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية الموظف"
      },
      {
        "language": "DE",
        "text": "Wohlbefinden der Mitarbeiter"
      },
      {
        "language": "IT",
        "text": "Benessere dei dipendenti"
      }
    ]
  },
  {
    "key": "txtOnBoarding",
    "text": "Employee Onboarding",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد وتهيئة الموظفين"
      },
      {
        "language": "DE",
        "text": "Mitarbeiter-Onboarding"
      },
      {
        "language": "IT",
        "text": "Onboarding dei dipendenti"
      }
    ]
  },
  {
    "key": "txt_Atleast1p_288",
    "text": "At least 1 permissions needs to be selected",
    "translations": [
      {
        "language": "AR",
        "text": "يجب تحديد إذن واحد على الأقل"
      },
      {
        "language": "DE",
        "text": "Mindestens 1 Berechtigung muss ausgewählt werden"
      },
      {
        "language": "IT",
        "text": "È necessario selezionare almeno un'autorizzazione"
      }
    ]
  },
  {
    "key": "txtExtraCriteria",
    "text": "Extra Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير اضافية"
      },
      {
        "language": "DE",
        "text": "Zusätzliche Kriterien"
      },
      {
        "language": "IT",
        "text": "Criteri aggiuntivi"
      }
    ]
  },
  {
    "key": "by",
    "text": "by",
    "translations": [
      {
        "language": "AR",
        "text": "حسب"
      },
      {
        "language": "DE",
        "text": "von"
      },
      {
        "language": "IT",
        "text": "di"
      }
    ]
  },
  {
    "key": "txt180FeedbackAssessment",
    "text": "180° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °180"
      },
      {
        "language": "FR",
        "text": "Évaluation du Commentaire ŕ 180°"
      },
      {
        "language": "DE",
        "text": "180° Feedback"
      },
      {
        "language": "IT",
        "text": "Feedback 180°"
      }
    ]
  },
  {
    "key": "txtEmployeeOnboardingAnalysis",
    "text": "Employee Onboarding",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد وتهيئة الموظفين"
      },
      {
        "language": "FR",
        "text": "Sortie de l'employé"
      },
      {
        "language": "DE",
        "text": "Mitarbeiter-Onboarding"
      },
      {
        "language": "IT",
        "text": "Onboarding dei dipendenti"
      }
    ]
  },
  {
    "key": "txt_COMPLETED",
    "text": "Completed",
    "translations": [
      {
        "language": "EN",
        "text": "Completed"
      },
      {
        "language": "AR",
        "text": "مُنجز"
      },
      {
        "language": "DE",
        "text": "Vollständig"
      },
      {
        "language": "IT",
        "text": "Completato"
      }
    ]
  },
  {
    "key": "txt_POSTED",
    "text": "Scheduled",
    "translations": [
      {
        "language": "EN",
        "text": "Scheduled"
      },
      {
        "language": "AR",
        "text": "مُجَدوَل"
      },
      {
        "language": "DE",
        "text": "Geplant"
      },
      {
        "language": "IT",
        "text": "Pianificato"
      }
    ]
  },
  {
    "key": "txt_EXPIRED",
    "text": "Expired",
    "translations": [
      {
        "language": "EN",
        "text": "Expired"
      },
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      },
      {
        "language": "DE",
        "text": "Abgelaufen"
      },
      {
        "language": "IT",
        "text": "Scaduto"
      }
    ]
  },
  {
    "key": "txt_PENDING",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم تعبئة الاستبيان"
      },
      {
        "language": "FR",
        "text": "En attente"
      },
      {
        "language": "DE",
        "text": "Nicht gestartet"
      },
      {
        "language": "IT",
        "text": "Non iniziato"
      }
    ]
  },
  {
    "key": "txt_ALL",
    "text": "All",
    "translations": [
      {
        "language": "EN",
        "text": "All"
      },
      {
        "language": "AR",
        "text": "الكل"
      },
      {
        "language": "DE",
        "text": "Alle"
      },
      {
        "language": "IT",
        "text": "Tutti"
      }
    ]
  },
  {
    "key": "btn_structure_new_entity",
    "text": "New Entity",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة وحدة"
      },
      {
        "language": "FR",
        "text": "Unité"
      },
      {
        "language": "DE",
        "text": "Neue Organisation"
      },
      {
        "language": "IT",
        "text": "Nuovo livello organizzativo"
      }
    ]
  },
  {
    "key": "txt_entity_group_name",
    "text": "New Entity",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unité"
      },
      {
        "language": "DE",
        "text": "Neue Entität"
      },
      {
        "language": "IT",
        "text": "Nuovo livello organizzativo"
      }
    ]
  },
  {
    "key": "Employee Experience Products Permission",
    "text": "Employee Experience Products Permission",
    "translations": [
      {
        "language": "AR",
        "text": "صلاحيات أدوات قياس وتحليل تجربة الموظفين"
      },
      {
        "language": "DE",
        "text": "Berechtigung für Produkte zur Mitarbeitererfahrung"
      },
      {
        "language": "IT",
        "text": "Autorizzazioni relative ai prodotti dell'Employee Experience"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_subject",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "FR",
        "text": "Confirmation"
      },
      {
        "language": "DE",
        "text": "Bestätigung"
      },
      {
        "language": "IT",
        "text": "Conferma"
      }
    ]
  },
  {
    "key": "btn_add_structure_entity",
    "text": "Add Entity",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة وحدة"
      },
      {
        "language": "FR",
        "text": "Ajouter une Entité"
      },
      {
        "language": "DE",
        "text": "Entität hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi un livello organizzativo"
      }
    ]
  },
  {
    "key": "txt_group_name",
    "text": "Entity Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الوحدة"
      },
      {
        "language": "FR",
        "text": "Type d’Unité"
      },
      {
        "language": "DE",
        "text": "Entitätstyp"
      },
      {
        "language": "IT",
        "text": "Tipo di livello organizzativo"
      }
    ]
  },
  {
    "key": "txtAccountManager",
    "text": "Account Manager",
    "translations": [
      {
        "language": "AR",
        "text": "مدير الحساب"
      },
      {
        "language": "DE",
        "text": "Account-Manager"
      },
      {
        "language": "IT",
        "text": "Account Manager"
      }
    ]
  },
  {
    "key": "txt_performance_rate",
    "text": "Performance Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تقييم الأداء"
      },
      {
        "language": "FR",
        "text": "Taux de Performance"
      },
      {
        "language": "DE",
        "text": "Leistungsrate"
      },
      {
        "language": "IT",
        "text": "Livello di performance"
      }
    ]
  },
  {
    "key": "txtAllocationDate",
    "text": "Allocation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التخصيص"
      },
      {
        "language": "FR",
        "text": "Date d'attribution"
      },
      {
        "language": "DE",
        "text": "Zuteilungsdatum"
      },
      {
        "language": "IT",
        "text": "Data di allocazione"
      }
    ]
  },
  {
    "key": "txtAllocationHistory",
    "text": "Allocation History",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التخصيص"
      },
      {
        "language": "FR",
        "text": "Historique de l'attribution"
      },
      {
        "language": "DE",
        "text": "Zuteilungsverlauf"
      },
      {
        "language": "IT",
        "text": "Cronologia delle allocazioni"
      }
    ]
  },
  {
    "key": "txtCurrentBalance",
    "text": "Current Balance",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد الحالي"
      },
      {
        "language": "FR",
        "text": "SOLDE courant"
      },
      {
        "language": "DE",
        "text": "Aktueller Kontostand"
      },
      {
        "language": "IT",
        "text": "Saldo attuale"
      }
    ]
  },
  {
    "key": "txt_delete_structure",
    "text": "Are you sure you want to delete this structure?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا الهيكل؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer cette structure?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Struktur wirklich löschen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questa struttura?"
      }
    ]
  },
  {
    "key": "txtUNITSPERPRODUCT",
    "text": "UNITS PER PRODUCT / Organization ",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة لكل منتج / مؤسسة "
      },
      {
        "language": "FR",
        "text": "UNITÉS PAR PRODUIT / société"
      },
      {
        "language": "DE",
        "text": "UNITS PRO PRODUKT / Organisation"
      },
      {
        "language": "IT",
        "text": "UNITÀ PER PRODOTTO/Organizzazione"
      }
    ]
  },
  {
    "key": "txtUsedUnits",
    "text": "Used Units",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات المستخدمة"
      },
      {
        "language": "FR",
        "text": "Unités Utilisées"
      },
      {
        "language": "DE",
        "text": "Verbrauchte Units"
      },
      {
        "language": "IT",
        "text": "Unità utilizzate"
      }
    ]
  },
  {
    "key": "txtExpiryDate",
    "text": "Expiry Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      },
      {
        "language": "FR",
        "text": "Date d'expiration"
      },
      {
        "language": "DE",
        "text": "Verfallsdatum"
      },
      {
        "language": "IT",
        "text": "Data di scadenza"
      }
    ]
  },
  {
    "key": "txtAssignUnits",
    "text": "Assign Units",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص الوحدات"
      },
      {
        "language": "FR",
        "text": "Assignation des Unités"
      },
      {
        "language": "DE",
        "text": "Units zuweisen"
      },
      {
        "language": "IT",
        "text": "Assegna un'unità"
      }
    ]
  },
  {
    "key": "txtAssign",
    "text": "Assign",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص"
      },
      {
        "language": "FR",
        "text": "Assigner "
      },
      {
        "language": "DE",
        "text": "Zuweisen"
      },
      {
        "language": "IT",
        "text": "Assegna"
      }
    ]
  },
  {
    "key": "txtPurchaseHistory",
    "text": "Purchase History",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الشراء"
      },
      {
        "language": "FR",
        "text": "Date des Achat"
      },
      {
        "language": "DE",
        "text": "Kaufhistorie"
      },
      {
        "language": "IT",
        "text": "Cronologia degli acquisti"
      }
    ]
  },
  {
    "key": "txtPurchasedUnits",
    "text": "Purchased Units",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات التي تم شراؤها"
      },
      {
        "language": "FR",
        "text": "Unités Achetées"
      },
      {
        "language": "DE",
        "text": "Gekaufte Units"
      },
      {
        "language": "IT",
        "text": "Unità acquistate"
      }
    ]
  },
  {
    "key": "txtProduct",
    "text": "Product",
    "translations": [
      {
        "language": "AR",
        "text": "المنتج"
      },
      {
        "language": "FR",
        "text": "Produit"
      },
      {
        "language": "DE",
        "text": "Produkt"
      },
      {
        "language": "IT",
        "text": "Prodotto"
      }
    ]
  },
  {
    "key": "txtDateofPurchase",
    "text": "Date of Purchase",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الشراء"
      },
      {
        "language": "FR",
        "text": "Date d'Achat"
      },
      {
        "language": "DE",
        "text": "Kaufdatum"
      },
      {
        "language": "IT",
        "text": "Data di acquisto"
      }
    ]
  },
  {
    "key": "txtLoader",
    "text": "Please wait...",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى الانتظار..."
      },
      {
        "language": "FR",
        "text": "S'il vous plaît, attendez..."
      },
      {
        "language": "HI",
        "text": "कृपया प्रतीक्षा करें…"
      },
      {
        "language": "TA",
        "text": "Mangyaring maghintay…"
      },
      {
        "language": "UR",
        "text": "براہ کرم انتظار کریں۔۔۔"
      },
      {
        "language": "BN",
        "text": "অনুগ্রহপূর্বক অপেক্ষা করুন…"
      },
      {
        "language": "DE",
        "text": "Bitte warten..."
      },
      {
        "language": "IT",
        "text": "Attendere prego..."
      }
    ]
  },
  {
    "key": "txt_units",
    "text": "Units",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unités"
      },
      {
        "language": "DE",
        "text": "Units"
      },
      {
        "language": "IT",
        "text": "Unità"
      }
    ]
  },
  {
    "key": "txt_unit",
    "text": "Unit",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unité"
      },
      {
        "language": "BN",
        "text": "ইউনিট"
      },
      {
        "language": "DE",
        "text": "Unit"
      },
      {
        "language": "IT",
        "text": "Unità"
      }
    ]
  },
  {
    "key": "txtNoPermission",
    "text": "You do not have permission to access this page; please contact the system administrator.",
    "translations": [
      {
        "language": "AR",
        "text": "ليس لديك الصلاحية لدخول هذه الصفحة؛ يرجى التواصل مع مسؤول النظام."
      },
      {
        "language": "DE",
        "text": "Sie haben keine Berechtigung, auf diese Seite zuzugreifen. Wenden Sie sich bitte an den Systemadministrator."
      },
      {
        "language": "IT",
        "text": "Non hai l'autorizzazione per accedere a questa pagina; contatta l'amministratore di sistema."
      }
    ]
  },
  {
    "key": "btnRequestUnits",
    "text": "Request Units",
    "translations": [
      {
        "language": "AR",
        "text": "طلب وحدات"
      },
      {
        "language": "FR",
        "text": "Demande d'Unités"
      },
      {
        "language": "DE",
        "text": "Anforderungseinheiten"
      },
      {
        "language": "IT",
        "text": "Richiedi le unità"
      }
    ]
  },
  {
    "key": "txtNoExpiry",
    "text": "No Expiry",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد تاريخ إنتهاء"
      },
      {
        "language": "FR",
        "text": "Pas de date d'expiration"
      },
      {
        "language": "DE",
        "text": "Kein Ablaufdatum"
      },
      {
        "language": "IT",
        "text": "Nessuna scadenza"
      }
    ]
  },
  {
    "key": "txtRequestSent",
    "text": "Request has been sent!",
    "translations": [
      {
        "language": "AR",
        "text": "لقد تكم إرسال طلبك!"
      },
      {
        "language": "FR",
        "text": "Votre demande a été envoyée !"
      },
      {
        "language": "DE",
        "text": "Anfrage wurde gesendet!"
      },
      {
        "language": "IT",
        "text": "Richiesta inviata!"
      }
    ]
  },
  {
    "key": "txt_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق"
      },
      {
        "language": "FR",
        "text": "Fermer"
      },
      {
        "language": "DE",
        "text": "Schließen"
      },
      {
        "language": "IT",
        "text": "Chiudi"
      }
    ]
  },
  {
    "key": "settings",
    "text": "Control Panel",
    "translations": [
      {
        "language": "AR",
        "text": "لوحة التحكم"
      },
      {
        "language": "FR",
        "text": "Panneau de Commande"
      },
      {
        "language": "DE",
        "text": "Bedienfeld"
      },
      {
        "language": "IT",
        "text": "Pannello di controllo"
      }
    ]
  },
  {
    "key": "txt_employee_exit",
    "text": "Employee Exit",
    "translations": [
      {
        "language": "AR",
        "text": "خروج الموظفين"
      },
      {
        "language": "FR",
        "text": "Sortie de l'employé"
      },
      {
        "language": "DE",
        "text": "Mitarbeiter Kündigung"
      },
      {
        "language": "IT",
        "text": "Employee Exit"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "FR",
        "text": "Rechercher"
      },
      {
        "language": "DE",
        "text": "Suchen"
      },
      {
        "language": "IT",
        "text": "Cerca"
      }
    ]
  },
  {
    "key": "txtEngagement",
    "text": "Employee Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "الاندماج الوظيفي"
      },
      {
        "language": "FR",
        "text": "Engagement de l'Employé"
      },
      {
        "language": "DE",
        "text": "Mitarbeiterengagement"
      },
      {
        "language": "IT",
        "text": "Engagement dei dipendenti"
      }
    ]
  },
  {
    "key": "txtAll",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الكل"
      },
      {
        "language": "FR",
        "text": "Tout"
      },
      {
        "language": "DE",
        "text": "Alle"
      },
      {
        "language": "IT",
        "text": "Tutti"
      }
    ]
  },
  {
    "key": "txtEmployeeHappiness",
    "text": "Employee Happiness",
    "translations": [
      {
        "language": "AR",
        "text": "سعادة الموظف"
      },
      {
        "language": "DE",
        "text": "Mitarbeiterzufriedenheit"
      },
      {
        "language": "IT",
        "text": "Felicità dei dipendenti"
      }
    ]
  },
  {
    "key": "txtClientID",
    "text": "Client ID",
    "translations": [
      {
        "language": "AR",
        "text": "هوية العميل"
      },
      {
        "language": "DE",
        "text": "Client-ID"
      },
      {
        "language": "IT",
        "text": "ID cliente"
      }
    ]
  },
  {
    "key": "txtAccountDetails",
    "text": "Account Details",
    "translations": [
      {
        "language": "AR",
        "text": "بيانات الحساب"
      },
      {
        "language": "DE",
        "text": "Kontodetails"
      },
      {
        "language": "IT",
        "text": "Dettagli dell'account"
      }
    ]
  },
  {
    "key": "txt_emp_ex_settings",
    "text": "EMPLOYEE EXPERIENCE SETTINGS",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط منصة تحليل تجربة الموظفين"
      },
      {
        "language": "DE",
        "text": "EINSTELLUNGEN FÜR DIE MITARBEITERERFAHRUNG"
      },
      {
        "language": "IT",
        "text": "IMPOSTAZIONI DELL'EMPLOYEE EXPERIENCE"
      }
    ]
  },
  {
    "key": "txtIntegration",
    "text": "Integration",
    "translations": [
      {
        "language": "AR",
        "text": "ترابط البيانات"
      },
      {
        "language": "DE",
        "text": "Integration"
      },
      {
        "language": "IT",
        "text": "Integrazione"
      }
    ]
  },
  {
    "key": "txtLogo",
    "text": "Organization Logo",
    "translations": [
      {
        "language": "AR",
        "text": "شعار المؤسسة "
      },
      {
        "language": "FR",
        "text": "Logo de la société"
      },
      {
        "language": "DE",
        "text": "Organisationslogo"
      },
      {
        "language": "IT",
        "text": "Logo dell'organizzazione"
      }
    ]
  },
  {
    "key": "txtWebsite",
    "text": "Website",
    "translations": [
      {
        "language": "AR",
        "text": "الموقع الإلكتروني"
      },
      {
        "language": "FR",
        "text": "Site Web "
      },
      {
        "language": "DE",
        "text": "Webseite"
      },
      {
        "language": "IT",
        "text": "Sito web"
      }
    ]
  },
  {
    "key": "btn_upload",
    "text": "Upload",
    "translations": [
      {
        "language": "AR",
        "text": "رفع"
      },
      {
        "language": "FR",
        "text": "Télécharger"
      },
      {
        "language": "DE",
        "text": "Hochladen"
      },
      {
        "language": "IT",
        "text": "Carica"
      }
    ]
  },
  {
    "key": "txtHeadQuarter",
    "text": "Headquarter",
    "translations": [
      {
        "language": "AR",
        "text": "المقر الرئيسي"
      },
      {
        "language": "FR",
        "text": "Sičge Social"
      },
      {
        "language": "DE",
        "text": "Hauptsitz"
      },
      {
        "language": "IT",
        "text": "Sede centrale"
      }
    ]
  },
  {
    "key": "txtResetPassword",
    "text": "Reset Password",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تعيين كلمة المرور"
      },
      {
        "language": "FR",
        "text": "Réinitialiser le mot de passe"
      },
      {
        "language": "DE",
        "text": "Passwort zurücksetzen"
      },
      {
        "language": "IT",
        "text": "Reimposta la password"
      }
    ]
  },
  {
    "key": "txtPassword",
    "text": "Password",
    "translations": [
      {
        "language": "AR",
        "text": "كلمة المرور"
      },
      {
        "language": "FR",
        "text": "Mot de Passe"
      },
      {
        "language": "DE",
        "text": "Passwort"
      },
      {
        "language": "IT",
        "text": "Password"
      }
    ]
  },
  {
    "key": "txtHidepassword",
    "text": "Hide password",
    "translations": [
      {
        "language": "AR",
        "text": "إخفاء كلمة المرور"
      },
      {
        "language": "FR",
        "text": "Masquer le mot de passe"
      },
      {
        "language": "DE",
        "text": "Passwort verbergen"
      },
      {
        "language": "IT",
        "text": "Nascondi la password"
      }
    ]
  },
  {
    "key": "txt_status",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "FR",
        "text": "Statut "
      },
      {
        "language": "DE",
        "text": "Status"
      },
      {
        "language": "IT",
        "text": "Stato"
      }
    ]
  },
  {
    "key": "btn_leaver_list_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": "Supprimer"
      },
      {
        "language": "DE",
        "text": "Löschen"
      },
      {
        "language": "IT",
        "text": "Elimina"
      }
    ]
  },
  {
    "key": "btn_leaver_list_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": "Modifier"
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "IT",
        "text": "Modifica"
      }
    ]
  },
  {
    "key": "txtWrongInfo",
    "text": "Wrong information provided, please try again.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إدخال معلومات خاطئة، يرجى المحاولة مرة أخرى."
      },
      {
        "language": "FR",
        "text": "please try again."
      },
      {
        "language": "DE",
        "text": "Falsche Informationen angegeben, bitte versuchen Sie es erneut."
      },
      {
        "language": "IT",
        "text": "Fornite informazioni errate, riprova."
      }
    ]
  },
  {
    "key": "txt_active",
    "text": "Active",
    "translations": [
      {
        "language": "AR",
        "text": "فعال"
      },
      {
        "language": "FR",
        "text": "Actif"
      },
      {
        "language": "DE",
        "text": "Aktiv"
      },
      {
        "language": "IT",
        "text": "Attivo"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "FR",
        "text": "D'accord"
      },
      {
        "language": "DE",
        "text": "Okay"
      },
      {
        "language": "IT",
        "text": "Ok"
      }
    ]
  },
  {
    "key": "used_by_products",
    "text": "This is being used by the following: <br>",
    "translations": [
      {
        "language": "AR",
        "text": "يتم استخدام هذا بواسطة ما يلي: <br>"
      },
      {
        "language": "FR",
        "text": "Ceci est utilisé par les éléments suivants : "
      },
      {
        "language": "DE",
        "text": "Dies wird von Folgendem verwendet: <br>"
      },
      {
        "language": "IT",
        "text": "Questo è utilizzato dai seguenti:\n"
      }
    ]
  },
  {
    "key": "used_by_exit_leaver",
    "text": "Employee Exit Survey <br>",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان خروج الموظفين <br>"
      },
      {
        "language": "FR",
        "text": "Enquęte sur les sorties des employés"
      },
      {
        "language": "DE",
        "text": "Mitarbeiteraustrittsbefragung <br>"
      },
      {
        "language": "IT",
        "text": "Survey \"Employee Exit\"\n"
      }
    ]
  },
  {
    "key": "used_by_engagement_survey",
    "text": "Employee Engagement Survey <br>",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان الاندماج الوظيفي <br>"
      },
      {
        "language": "FR",
        "text": "Enquęte sur l’engagement des employés <br>"
      },
      {
        "language": "BN",
        "text": "কর্মচারী নিয়োগ সমীক্ষা <br>"
      },
      {
        "language": "DE",
        "text": "Umfrage zum Mitarbeiterengagement <br>"
      },
      {
        "language": "IT",
        "text": "Employee Engagement Survey"
      }
    ]
  },
  {
    "key": "used_by_assessment_survey",
    "text": "360° Feedback <br>",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360 <br>"
      },
      {
        "language": "FR",
        "text": "Commentaire ŕ 360° "
      },
      {
        "language": "DE",
        "text": "360° Feedback <br>"
      },
      {
        "language": "IT",
        "text": "Feedback 360°\n"
      }
    ]
  },
  {
    "key": "txt_yes",
    "text": "Yes",
    "translations": [
      {
        "language": "AR",
        "text": "نعم"
      },
      {
        "language": "FR",
        "text": "Oui"
      },
      {
        "language": "DE",
        "text": "Ja"
      },
      {
        "language": "IT",
        "text": "Sì"
      }
    ]
  },
  {
    "key": "txt_delete_performance",
    "text": "Are you sure you want to delete this Performance Rate?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف معدل تقييم الأداء هذا؟"
      },
      {
        "language": "FR",
        "text": "Etes-vous sűr de vouloir supprimer ce taux de performance ?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Leistungsrate wirklich löschen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo livello di performance?"
      }
    ]
  },
  {
    "key": "txt_delete_performance_denied",
    "text": "Unable to delete, there are leavers assigned to this Performance Rate",
    "translations": [
      {
        "language": "AR",
        "text": "غير قابل للحذف، هناك موظفين مغادرين مرتبطين بمعدل الأداء هذا."
      },
      {
        "language": "DE",
        "text": "Löschen nicht möglich, dieser Leistungsrate sind Aussteiger zugewiesen"
      },
      {
        "language": "IT",
        "text": "Impossibile eliminare, ci sono dipendenti in uscita associati a questo livello di performance"
      }
    ]
  },
  {
    "key": "txt_delete_denied",
    "text": "Unable to delete",
    "translations": [
      {
        "language": "AR",
        "text": "غير قابل للحذف"
      },
      {
        "language": "FR",
        "text": "Impossible de supprimer"
      },
      {
        "language": "DE",
        "text": "Löschen nicht möglich"
      },
      {
        "language": "IT",
        "text": "Impossibile eliminare"
      }
    ]
  },
  {
    "key": "txt_required_field",
    "text": "This field is required",
    "translations": [
      {
        "language": "AR",
        "text": "هذا الحقل إجباري"
      },
      {
        "language": "FR",
        "text": "Ce champ est requis"
      },
      {
        "language": "DE",
        "text": "Dieses Feld ist erforderlich"
      },
      {
        "language": "IT",
        "text": "Questo campo è obbligatorio"
      }
    ]
  },
  {
    "key": "btn_add_user",
    "text": "Add User",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستخدم"
      },
      {
        "language": "FR",
        "text": "Ajouter un Utilisateur"
      },
      {
        "language": "DE",
        "text": "Benutzer hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi un utente"
      }
    ]
  },
  {
    "key": "btn_edit_user",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": "Modifier"
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "IT",
        "text": "Modifica"
      }
    ]
  },
  {
    "key": "txt_wrong_text_count",
    "text": "Exceeded text limit.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز عدد الأحرف المسموح به"
      },
      {
        "language": "FR",
        "text": "Limite de texte dépassée."
      },
      {
        "language": "DE",
        "text": "Textlimit überschritten."
      },
      {
        "language": "IT",
        "text": "Limite di testo superato."
      }
    ]
  },
  {
    "key": "txtEmailPssword",
    "text": "Please provide both your email and password to login.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال بريدك الإلكتروني وكلمة السر لتسجيل الدخول."
      },
      {
        "language": "FR",
        "text": "Veuillez fournir votre Email et votre mot de passe pour vous connecter."
      },
      {
        "language": "DE",
        "text": "Bitte geben Sie zum Anmelden sowohl Ihre E-Mail-Adresse als auch Ihr Passwort ein."
      },
      {
        "language": "IT",
        "text": "Inserisci l'email e la password per accedere."
      }
    ]
  },
  {
    "key": "txt_user_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": "Email (Courrier électronique)"
      },
      {
        "language": "BN",
        "text": "ইমেইল"
      },
      {
        "language": "DE",
        "text": "E-Mail"
      },
      {
        "language": "IT",
        "text": "Email"
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      },
      {
        "language": "FR",
        "text": "Mettre ŕ jour"
      },
      {
        "language": "DE",
        "text": "Aktualisieren"
      },
      {
        "language": "IT",
        "text": "Aggiorna"
      }
    ]
  },
  {
    "key": "btn_add",
    "text": "Add",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة"
      },
      {
        "language": "FR",
        "text": "Ajouter"
      },
      {
        "language": "DE",
        "text": "Hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi"
      }
    ]
  },
  {
    "key": "txt_update_entity_group",
    "text": "Successfully Updated",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح"
      },
      {
        "language": "FR",
        "text": "Mise ŕ Jour avec Succčs"
      },
      {
        "language": "DE",
        "text": "Erfolgreich aktualisiert"
      },
      {
        "language": "IT",
        "text": "Aggiornato con successo"
      }
    ]
  },
  {
    "key": "txt_delete_entity_group",
    "text": "Successfully Deleted",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحذف بنجاح "
      },
      {
        "language": "FR",
        "text": "Supprimé avec succčs"
      },
      {
        "language": "DE",
        "text": "Erfolgreich gelöscht"
      },
      {
        "language": "IT",
        "text": "Eliminato con successo"
      }
    ]
  },
  {
    "key": "txtsuccess",
    "text": "Success",
    "translations": [
      {
        "language": "AR",
        "text": "تمت العملية بنجاح"
      },
      {
        "language": "FR",
        "text": "Succčs"
      },
      {
        "language": "DE",
        "text": "Erfolg"
      },
      {
        "language": "IT",
        "text": "Successo"
      }
    ]
  },
  {
    "key": "txt_add_entity_group",
    "text": "Successfully Added",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح "
      },
      {
        "language": "FR",
        "text": "Ajouter avec Succčs"
      },
      {
        "language": "DE",
        "text": "Erfolgreich hinzugefügt"
      },
      {
        "language": "IT",
        "text": "Aggiunto con successo"
      }
    ]
  },
  {
    "key": "txt_performance_rate",
    "text": "Performance Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تقييم الأداء"
      },
      {
        "language": "FR",
        "text": "Taux de Performance"
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_performance_rate_value",
    "text": "Performance Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تقييم الأداء"
      },
      {
        "language": "FR",
        "text": "Taux de Performance"
      },
      {
        "language": "DE",
        "text": "Leistungsrate"
      },
      {
        "language": "IT",
        "text": "Livello di performance"
      }
    ]
  },
  {
    "key": "txt_performance_rate_description",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      },
      {
        "language": "FR",
        "text": "Description"
      },
      {
        "language": "DE",
        "text": "Beschreibung"
      },
      {
        "language": "IT",
        "text": "Descrizione"
      }
    ]
  },
  {
    "key": "btn_performance_add",
    "text": "Add Performance Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تقييم أداء"
      },
      {
        "language": "FR",
        "text": "Ajouter Un Taux de Performance"
      },
      {
        "language": "DE",
        "text": "Leistungsrate hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi un livello di performance"
      }
    ]
  },
  {
    "key": "txt_or",
    "text": "Or",
    "translations": [
      {
        "language": "AR",
        "text": "أو"
      },
      {
        "language": "DE",
        "text": "Oder"
      },
      {
        "language": "IT",
        "text": "O"
      }
    ]
  },
  {
    "key": "txtCheckEmails",
    "text": "Request sent, please check your email",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال الطلب، يرجى التحقق من بريدك الإلكتروني"
      },
      {
        "language": "FR",
        "text": "please check your email"
      },
      {
        "language": "DE",
        "text": "Anfrage gesendet, bitte überprüfen Sie Ihre E-Mail"
      },
      {
        "language": "IT",
        "text": "Richiesta inviata, controlla la tua email"
      }
    ]
  },
  {
    "key": "txtEnterEmail",
    "text": "Please, enter an email",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال بريد إلكتروني"
      },
      {
        "language": "DE",
        "text": "Bitte geben Sie eine E-Mail ein"
      },
      {
        "language": "IT",
        "text": "Inserisci un'email"
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا الاستبيان"
      },
      {
        "language": "FR",
        "text": "#UNITS# les unités seront déduites pour cette action"
      },
      {
        "language": "DE",
        "text": "Für diese Aktion werden #UNITS# Units abgezogen"
      },
      {
        "language": "IT",
        "text": "Verranno detratte #UNITS# unità per quest'azione"
      }
    ]
  },
  {
    "key": "txt_unit_allocation_confirmation",
    "text": "These #UNITS# units cannot be returned or reassigned to another service.",
    "translations": [
      {
        "language": "AR",
        "text": "هذه ال #UNITS# وحدة لا يمكن استرجاعها أو تخصيصها لخدمة أخرى لاحقاً"
      },
      {
        "language": "FR",
        "text": "Ces unités #UNITS# ne peuvent pas ętre retournées ou réaffectées ŕ un autre service."
      },
      {
        "language": "DE",
        "text": "Diese #UNITS# Units können nicht zurückgegeben oder einem anderen Dienst neu zugewiesen werden."
      },
      {
        "language": "IT",
        "text": "Queste #UNITS# unità non possono essere restituite o riassegnate ad un altro servizio."
      }
    ]
  },
  {
    "key": "txt_allocation_confirmation",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "FR",
        "text": "Confirmation"
      },
      {
        "language": "DE",
        "text": "Bestätigung"
      },
      {
        "language": "IT",
        "text": "Conferma"
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_message",
    "text": "Are you sure you want to delete this respondent?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا المستجيب؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer ce répondant?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diesen Befragten wirklich löschen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo rispondente?"
      }
    ]
  },
  {
    "key": "txt_remove_respondents_confirmation_message",
    "text": "Are you sure you want to delete these respondents?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هؤلاء المستجيبون؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer ces répondants?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Befragten wirklich löschen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questi rispondenti?"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_message_assessment",
    "text": "Are you sure you want to delete this Assessment?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا التقييم؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer cette évaluation?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Bewertung wirklich löschen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo Assessment?"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_message",
    "text": "Are you sure you want to delete this survey?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا الاستبيان؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer cet enquęte?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Umfrage wirklich löschen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questa survey?"
      }
    ]
  },
  {
    "key": "txtDontShow",
    "text": "Do not show this message again",
    "translations": [
      {
        "language": "AR",
        "text": "لا تظهر هذه الرسالة مرة أخرى"
      },
      {
        "language": "FR",
        "text": "Ce message n’apparaît plus"
      },
      {
        "language": "DE",
        "text": "Diese Meldung nicht mehr anzeigen"
      },
      {
        "language": "IT",
        "text": "Non mostrare più questo messaggio"
      }
    ]
  },
  {
    "key": "txt_unitsPopupTile",
    "text": "Unit(s) Received!",
    "translations": [
      {
        "language": "AR",
        "text": "تم إضافة الوحدات!"
      },
      {
        "language": "FR",
        "text": "Unités reçues!"
      },
      {
        "language": "DE",
        "text": "Unit(s) erhalten!"
      },
      {
        "language": "IT",
        "text": "Unità ricevute!"
      }
    ]
  },
  {
    "key": "txt_units_main_balance",
    "text": "Your account has been credited with #UNITS# unit(s)",
    "translations": [
      {
        "language": "AR",
        "text": "تمت إضافة #UNITS# وحدة إلى حسابك"
      },
      {
        "language": "FR",
        "text": "Votre compte a été crédité d'unités #UNITS#"
      },
      {
        "language": "DE",
        "text": "Ihrem Konto wurden #UNITS# Unit(s) gutgeschrieben"
      },
      {
        "language": "IT",
        "text": "Sono state accreditate #UNITS# unità sul tuo account"
      }
    ]
  },
  {
    "key": "txt_units_survey_balance",
    "text": "#COMPANYNAME# has been credited with #UNITS# unit(s) for #SURVEYNAME#",
    "translations": [
      {
        "language": "AR",
        "text": "تم إضافة #UNITS# وحدات ل#SURVEYNAME# لحساب #COMPANYNAME#"
      },
      {
        "language": "FR",
        "text": "#COMPANYNAME# a été crédité d'unités #UNITS# pour #SURVEYNAM #"
      },
      {
        "language": "DE",
        "text": "#COMPANYNAME# wurden #UNITS# Unit(s) für #SURVEYNAME# gutgeschrieben."
      },
      {
        "language": "IT",
        "text": "Sono state accreditate #UNITS# unità sull'account di #COMPANYNAME# per #SURVEYNAME#"
      }
    ]
  },
  {
    "key": "txt_unitsAdded",
    "text": "Unit(s) Added",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات المضافة"
      },
      {
        "language": "FR",
        "text": "Unités Ajoutées"
      },
      {
        "language": "DE",
        "text": "Unit(s) hinzugefügt"
      },
      {
        "language": "IT",
        "text": "Unità aggiunta/e"
      }
    ]
  },
  {
    "key": "txt_totalUnits",
    "text": "New Total Balance",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي الرصيد الجديد"
      },
      {
        "language": "FR",
        "text": "Nouveau Solde Total"
      },
      {
        "language": "DE",
        "text": "Neuer Gesamtsaldo"
      },
      {
        "language": "IT",
        "text": "Nuovo saldo totale"
      }
    ]
  },
  {
    "key": "txt_units",
    "text": "Units",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unités"
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "noUnits",
    "text": "Please, add at least one unit to proceed.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إضافة وحدة واحدة على الأقل للمتابعة."
      },
      {
        "language": "FR",
        "text": "add at least one unit to proceed."
      },
      {
        "language": "DE",
        "text": "Bitte fügen Sie mindestens eine Unit hinzu, um fortzufahren."
      },
      {
        "language": "IT",
        "text": "Aggiungi almeno un'unità per continuare."
      }
    ]
  },
  {
    "key": "txt_unit",
    "text": "Unit",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unité"
      },
      {
        "language": "BN",
        "text": "ইউনিট"
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAccountOverview",
    "text": "Account Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة على الحساب"
      },
      {
        "language": "FR",
        "text": "Aperçu du Compte"
      },
      {
        "language": "DE",
        "text": "Kontoübersicht"
      },
      {
        "language": "IT",
        "text": "Panoramica dell'account"
      }
    ]
  },
  {
    "key": "overview",
    "text": "Account Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة على الحساب"
      },
      {
        "language": "FR",
        "text": "Aperçu du Compte"
      },
      {
        "language": "DE",
        "text": "Kontoübersicht"
      },
      {
        "language": "IT",
        "text": "Panoramica dell'account"
      }
    ]
  },
  {
    "key": "txt360DegreeFeedback",
    "text": "360° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم °360"
      },
      {
        "language": "FR",
        "text": "Commentaire ŕ 360°"
      },
      {
        "language": "DE",
        "text": "360° Feedback"
      },
      {
        "language": "IT",
        "text": "Feedback 360°"
      }
    ]
  },
  {
    "key": "txtEmployeeExperience",
    "text": "Employee Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة الموظفين"
      },
      {
        "language": "FR",
        "text": "Expérience des employés"
      },
      {
        "language": "DE",
        "text": "Mitarbeitererfahrung"
      },
      {
        "language": "IT",
        "text": "Employee Experience"
      }
    ]
  },
  {
    "key": "txtAccountOverviewDesc",
    "text": "View and manage your account information",
    "translations": [
      {
        "language": "AR",
        "text": "عرض وإدارة معلومات حسابك"
      },
      {
        "language": "FR",
        "text": "Voir et gérer les informations de votre compte"
      },
      {
        "language": "DE",
        "text": "Anzeigen und Verwalten Ihrer Kontoinformationen"
      },
      {
        "language": "IT",
        "text": "Visualizza e gestisci le informazioni del tuo account"
      }
    ]
  },
  {
    "key": "txtRemainingBalance",
    "text": "Remaining Balance",
    "translations": [
      {
        "language": "AR",
        "text": "الرصيد المتبقي"
      },
      {
        "language": "FR",
        "text": "Solde Restant"
      },
      {
        "language": "DE",
        "text": "Restguthaben"
      },
      {
        "language": "IT",
        "text": "Saldo rimanente"
      }
    ]
  },
  {
    "key": "btnRequestUnits",
    "text": "Request Units",
    "translations": [
      {
        "language": "AR",
        "text": "طلب وحدات"
      },
      {
        "language": "FR",
        "text": "Demande d'Unités"
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUnitsperModule",
    "text": "Units per Product",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات لكل منتج"
      },
      {
        "language": "FR",
        "text": "Unités par Produit"
      },
      {
        "language": "DE",
        "text": "Units pro Produkt"
      },
      {
        "language": "IT",
        "text": "Unità per prodotto"
      }
    ]
  },
  {
    "key": "txtCurrentunits",
    "text": "Current units:",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات الحالية:"
      },
      {
        "language": "FR",
        "text": "Unités Actuelles:"
      },
      {
        "language": "DE",
        "text": "Aktuelle Units:"
      },
      {
        "language": "IT",
        "text": "Unità attuali:"
      }
    ]
  },
  {
    "key": "txtAllocatedUnits",
    "text": "Allocated Units:",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدات المخصصة:"
      },
      {
        "language": "FR",
        "text": "Unités Allouées:"
      },
      {
        "language": "DE",
        "text": "Zugewiesene Units:"
      },
      {
        "language": "IT",
        "text": "Unità allocate:"
      }
    ]
  },
  {
    "key": "txtEmployeeExitAnalysis",
    "text": "Employee Exit",
    "translations": [
      {
        "language": "AR",
        "text": "خروج الموظفين"
      },
      {
        "language": "FR",
        "text": "Sortie de l'employé"
      },
      {
        "language": "DE",
        "text": "Mitarbeiter Kündigung"
      },
      {
        "language": "IT",
        "text": "Employee Exit"
      }
    ]
  },
  {
    "key": "txt_Q-STARTED",
    "text": "Survey Started",
    "translations": [
      {
        "language": "AR",
        "text": "تم بدء الاستبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte  Commencé"
      },
      {
        "language": "DE",
        "text": "Umfrage gestartet"
      },
      {
        "language": "IT",
        "text": "Survey iniziata"
      }
    ]
  },
  {
    "key": "txt_Q-SUBMITTED",
    "text": "Survey Submitted",
    "translations": [
      {
        "language": "AR",
        "text": "تم تسليم الاستبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte Soumis"
      },
      {
        "language": "DE",
        "text": "Umfrage eingereicht"
      },
      {
        "language": "IT",
        "text": "Survey inviata"
      }
    ]
  },
  {
    "key": "txt_Q-EXPIRING",
    "text": "Survey Expiring",
    "translations": [
      {
        "language": "AR",
        "text": "قاربت صلاحية الاستبيان على الانتهاء"
      },
      {
        "language": "FR",
        "text": "Enquęte Expirant"
      },
      {
        "language": "DE",
        "text": "Umfrage läuft ab"
      },
      {
        "language": "IT",
        "text": "Survey in scadenza"
      }
    ]
  },
  {
    "key": "txt_Q-EXPIRED",
    "text": "Survey Expired",
    "translations": [
      {
        "language": "AR",
        "text": "انتهت صلاحية الاستبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte Expirée"
      },
      {
        "language": "DE",
        "text": "Umfrage abgelaufen"
      },
      {
        "language": "IT",
        "text": "Survey scaduta"
      }
    ]
  },
  {
    "key": "txt_notification_questionnaire_expiring",
    "text": "Questionnaire for respondent is about to expire",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان لمستجيب على وشك الانتهاء"
      },
      {
        "language": "DE",
        "text": "Der Fragebogen für den Befragten läuft bald ab"
      },
      {
        "language": "IT",
        "text": "Il questionario per il rispondente sta per scadere"
      }
    ]
  },
  {
    "key": "txt_notification_questionnaire_started",
    "text": "#LEAVERNAME# has started the #QUESTIONNAIRE#",
    "translations": [
      {
        "language": "AR",
        "text": "بدأ #LEAVERNAME# #QUESTIONNAIRE#"
      },
      {
        "language": "FR",
        "text": "#LEAVERNAME# a commencé le #QUESTIONNAIRE#"
      },
      {
        "language": "DE",
        "text": "#LEAVERNAME# hat den #FRAGEBOGEN# begonnen"
      },
      {
        "language": "IT",
        "text": "#LEAVERNAME# ha avviato il #QUESTIONNAIRE#"
      }
    ]
  },
  {
    "key": "txt_notification_questionnaire_completed",
    "text": "#LEAVERNAME# has completed the #QUESTIONNAIRE#",
    "translations": [
      {
        "language": "AR",
        "text": "اكمل #LEAVERNAME# #QUESTIONNAIRE#"
      },
      {
        "language": "FR",
        "text": "#LEAVERNAME# a terminé le #QUESTIONNAIRE#"
      },
      {
        "language": "DE",
        "text": "#LEAVERNAME# hat den #FRAGEBOGEN# ausgefüllt"
      },
      {
        "language": "IT",
        "text": "#LEAVERNAME# ha completato il #QUESTIONNAIRE#"
      }
    ]
  },
  {
    "key": "txt_delete_job_grade",
    "text": "Are you sure you want to delete this Job Grade?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذه الدرجة الوظيفية؟"
      },
      {
        "language": "FR",
        "text": "Etes-vous sűr de vouloir supprimer cette catégorie d’emploi?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Job-Stufe wirklich löschen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questa categoria professionale?"
      }
    ]
  },
  {
    "key": "txt_subject_password_resetConfirmation",
    "text": "Reset Password",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تعيين كلمة المرور"
      },
      {
        "language": "FR",
        "text": "Réinitialiser le mot de passe"
      },
      {
        "language": "DE",
        "text": "Passwort zurücksetzen"
      },
      {
        "language": "IT",
        "text": "Reimposta la password"
      }
    ]
  },
  {
    "key": "txt_Password_resetConfirmation",
    "text": "Are you sure you want to reset account password for #EMAIL# ?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد إعادة تعيين كلمة المرور ل #EMAIL# ؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir réinitialiser le mot de passe du compte pour #EMAIL# ?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie das Kontokennwort für #EMAIL# wirklich zurücksetzen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero reimpostare la password per #EMAIL#?"
      }
    ]
  },
  {
    "key": "txt_delete_band_level",
    "text": "Are you sure you want to delete this Band Level?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف المستوى الوظيفي هذا؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir supprimer ce niveau de tranche?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diese Stufe wirklich löschen?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero eliminare questo inquadramento?"
      }
    ]
  },
  {
    "key": "txt_delete_band_level_denied",
    "text": "Unable to delete, there are leavers assigned to this Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "غير قابل للحذف، هناك موظفين مغادرين مرتبطين بهذا المستوى الوظيفي."
      },
      {
        "language": "DE",
        "text": "Löschen nicht möglich, dieser Stufe sind Abgänger zugewiesen"
      },
      {
        "language": "IT",
        "text": "Impossibile eliminare, ci sono dipendenti in uscita associati a questo inquadramento"
      }
    ]
  },
  {
    "key": "txt_notification_questionnaire_expired",
    "text": "Questionnaire for respondent has expired",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان لمستجيب قد انتهى"
      },
      {
        "language": "DE",
        "text": "Fragebogen für Befragten ist abgelaufen"
      },
      {
        "language": "IT",
        "text": "Il questionario per il rispondente è scaduto"
      }
    ]
  },
  {
    "key": "txt_notification_settings",
    "text": "Notification Settings",
    "translations": [
      {
        "language": "AR",
        "text": "إعدادات الإشعارات"
      },
      {
        "language": "FR",
        "text": "Paramčtres de Notifications"
      },
      {
        "language": "DE",
        "text": "Benachrichtigungseinstellungen"
      },
      {
        "language": "IT",
        "text": "Impostazioni delle notifiche"
      }
    ]
  },
  {
    "key": "txt_notification_expired_questionnaire",
    "text": "Expired Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان منتهي الصلاحية"
      },
      {
        "language": "FR",
        "text": "Enquęte expirée"
      },
      {
        "language": "DE",
        "text": "Abgelaufene Umfrage"
      },
      {
        "language": "IT",
        "text": "Survey scaduta"
      }
    ]
  },
  {
    "key": "txt_delete_user",
    "text": "Are you sure you want to deactivate this user?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد تعطيل هذا المستخدم؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir désactiver cet utilisateur?"
      },
      {
        "language": "DE",
        "text": "Möchten Sie diesen Benutzer wirklich deaktivieren?"
      },
      {
        "language": "IT",
        "text": "Vuoi davvero disattivare questo utente?"
      }
    ]
  },
  {
    "key": "txt_notification_completed_questionnaire",
    "text": "Completed Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان مكتمل"
      },
      {
        "language": "FR",
        "text": "Enquęte complétée"
      },
      {
        "language": "DE",
        "text": "Abgeschlossene Umfrage"
      },
      {
        "language": "IT",
        "text": "Survey completata"
      }
    ]
  },
  {
    "key": "txt_notification_expiring_questionnaire",
    "text": "Survey about to expire (3 days prior)",
    "translations": [
      {
        "language": "AR",
        "text": "باقي 3 أيام على انتهاء صلاحية الاستبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte sur le point d'expirer (dans 3 jours) "
      },
      {
        "language": "DE",
        "text": "Umfrage läuft bald ab (3 Tage vorher)"
      },
      {
        "language": "IT",
        "text": "Survey in scadenza (3 giorni prima)"
      }
    ]
  },
  {
    "key": "txt_notification_remaining_units",
    "text": "Survey units is 20% or less",
    "translations": [
      {
        "language": "AR",
        "text": "متبقي 20% أو أقل من الوحدات"
      },
      {
        "language": "FR",
        "text": "Les unités de Enquęte sont 20% ou moins"
      },
      {
        "language": "DE",
        "text": "Umfrage units betragen 20 % oder weniger"
      },
      {
        "language": "IT",
        "text": "Le unità della survey sono al 20% o meno"
      }
    ]
  },
  {
    "key": "txt_notification_subscription_expiring",
    "text": "Subscription is about to expire in 2 months",
    "translations": [
      {
        "language": "AR",
        "text": "سينتهي اشتراكك خلال شهرين"
      },
      {
        "language": "FR",
        "text": "L’abonnement est sur le point d’expirer dans 2 mois"
      },
      {
        "language": "DE",
        "text": "Das Abonnement läuft in 2 Monaten ab"
      },
      {
        "language": "IT",
        "text": "L'abbonamento scadrà tra 2 mesi"
      }
    ]
  },
  {
    "key": "txt_notification_subscription_expired",
    "text": "Subscription has expired",
    "translations": [
      {
        "language": "AR",
        "text": "انتهت صلاحية الاشتراك"
      },
      {
        "language": "FR",
        "text": "L'abonnement a expiré"
      },
      {
        "language": "DE",
        "text": "Abonnement ist abgelaufen"
      },
      {
        "language": "IT",
        "text": "L'abbonamento è scaduto"
      }
    ]
  },
  {
    "key": "txt_notification_notification_started",
    "text": "Survey started",
    "translations": [
      {
        "language": "AR",
        "text": "تم بدء الاستبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte  Commencé"
      },
      {
        "language": "DE",
        "text": "Umfrage gestartet"
      },
      {
        "language": "IT",
        "text": "Survey iniziata"
      }
    ]
  },
  {
    "key": "txt_modal_band",
    "text": "Add Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستوى وظيفي "
      },
      {
        "language": "FR",
        "text": "Nouveau Niveau Fonctionnel"
      },
      {
        "language": "DE",
        "text": "Level hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi un inquadramento"
      }
    ]
  },
  {
    "key": "txt_performance_icon",
    "text": "Icon",
    "translations": [
      {
        "language": "AR",
        "text": "رمز "
      },
      {
        "language": "FR",
        "text": "Icône"
      },
      {
        "language": "DE",
        "text": "Symbol"
      },
      {
        "language": "IT",
        "text": "Icona"
      }
    ]
  },
  {
    "key": "txt_bandlevel",
    "text": "Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "المستوى الوظيفي"
      },
      {
        "language": "FR",
        "text": "Le Niveau de tranche"
      },
      {
        "language": "DE",
        "text": "Level-Höhe"
      },
      {
        "language": "IT",
        "text": "Inquadramento"
      }
    ]
  },
  {
    "key": "btn_add_band_level",
    "text": "Add Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستوى وظيفي"
      },
      {
        "language": "FR",
        "text": "Ajouter un niveau de la tranche "
      },
      {
        "language": "DE",
        "text": "Level hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi un inquadramento"
      }
    ]
  },
  {
    "key": "txt_band_level_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "FR",
        "text": "Nom "
      },
      {
        "language": "DE",
        "text": "Name"
      },
      {
        "language": "IT",
        "text": "Nome"
      }
    ]
  },
  {
    "key": "btn_edit_band_level",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": "Modifier"
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "IT",
        "text": "Modifica"
      }
    ]
  },
  {
    "key": "btn_remove_band_level",
    "text": "Remove",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": "Supprimer"
      },
      {
        "language": "DE",
        "text": "Entfernen"
      },
      {
        "language": "IT",
        "text": "Rimuovi"
      }
    ]
  },
  {
    "key": "btn_add_job_grade",
    "text": "Add Job Grade",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة درجة وظيفية"
      },
      {
        "language": "FR",
        "text": "Ajouter une Catégorie d’Emploi"
      },
      {
        "language": "DE",
        "text": "Job-Grad hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi una categoria professionale"
      }
    ]
  },
  {
    "key": "btn_edit_job_grade",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": "Modifier "
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "IT",
        "text": "Modifica"
      }
    ]
  },
  {
    "key": "btn_remove_job_grade",
    "text": "Remove",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": "Supprimer"
      },
      {
        "language": "DE",
        "text": "Entfernen"
      },
      {
        "language": "IT",
        "text": "Rimuovi"
      }
    ]
  },
  {
    "key": "txt_company_name",
    "text": "Organization Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المؤسسة"
      },
      {
        "language": "FR",
        "text": "Nom de la société"
      },
      {
        "language": "DE",
        "text": "Name der Organisation"
      },
      {
        "language": "IT",
        "text": "Nome dell'organizzazione"
      }
    ]
  },
  {
    "key": "txtResetEmail",
    "text": "Password reset email sent",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال بريد إلكتروني لإعادة تعيين كلمة السر"
      },
      {
        "language": "FR",
        "text": "Réinitialisation du mot de passe, Email envoyé"
      },
      {
        "language": "DE",
        "text": "E-Mail zum Zurücksetzen des Passworts gesendet"
      },
      {
        "language": "IT",
        "text": "Email per il reset della password inviata"
      }
    ]
  },
  {
    "key": "txtSthWrong",
    "text": "Something went wrong",
    "translations": [
      {
        "language": "AR",
        "text": "لقد حدث خطأ, يرجى المحاولة مرة أخرى"
      },
      {
        "language": "DE",
        "text": "Da ist etwas schiefgelaufen"
      },
      {
        "language": "IT",
        "text": "Qualcosa è andato storto"
      }
    ]
  },
  {
    "key": "txt_company_industry",
    "text": "Organization Industry",
    "translations": [
      {
        "language": "AR",
        "text": "قطاع المؤسسة"
      },
      {
        "language": "FR",
        "text": "Secteur de la société"
      },
      {
        "language": "DE",
        "text": "Industrie"
      },
      {
        "language": "IT",
        "text": "Settore aziendale"
      }
    ]
  },
  {
    "key": "txt_company_size",
    "text": "Organization Size",
    "translations": [
      {
        "language": "AR",
        "text": "حجم المؤسسة"
      },
      {
        "language": "FR",
        "text": "Taille de la société"
      },
      {
        "language": "DE",
        "text": "Unternehmensgröße"
      },
      {
        "language": "IT",
        "text": "Dimensione dell'organizzazione"
      }
    ]
  },
  {
    "key": "btn_company_add",
    "text": "Add Organization ",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مؤسسة"
      },
      {
        "language": "FR",
        "text": "Ajouter une Société"
      },
      {
        "language": "DE",
        "text": " Organisation hinzufügen"
      },
      {
        "language": "IT",
        "text": "Aggiungi un'organizzazione"
      }
    ]
  },
  {
    "key": "btn_company_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": "Modifier"
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "IT",
        "text": "Modifica"
      }
    ]
  },
  {
    "key": "btn_company_remove",
    "text": "Remove",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": "Supprimer"
      },
      {
        "language": "DE",
        "text": "Entfernen"
      },
      {
        "language": "IT",
        "text": "Rimuovi"
      }
    ]
  },
  {
    "key": "txt_branches",
    "text": "Location / Branches",
    "translations": [
      {
        "language": "AR",
        "text": "الموقع / الفروع"
      },
      {
        "language": "FR",
        "text": "Emplacement / Succursales"
      },
      {
        "language": "DE",
        "text": "Standort / Niederlassungen"
      },
      {
        "language": "IT",
        "text": "Sedi/Filiali"
      }
    ]
  },
  {
    "key": "txt_country_code",
    "text": "Country Code",
    "translations": [
      {
        "language": "AR",
        "text": "رمز الدولة"
      },
      {
        "language": "FR",
        "text": "Code postal"
      },
      {
        "language": "DE",
        "text": "Landesvorwahl"
      },
      {
        "language": "IT",
        "text": "Prefisso internazionale"
      }
    ]
  },
  {
    "key": "txt_contact_number",
    "text": "Contact Number",
    "translations": [
      {
        "language": "AR",
        "text": "رقم الاتصال"
      },
      {
        "language": "FR",
        "text": "Numéro de Contact"
      },
      {
        "language": "DE",
        "text": "Kontaktnummer"
      },
      {
        "language": "IT",
        "text": "Numero di contatto"
      }
    ]
  },
  {
    "key": "btn_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      },
      {
        "language": "FR",
        "text": "SUIVANT"
      },
      {
        "language": "DE",
        "text": "Nächste"
      },
      {
        "language": "IT",
        "text": "Avanti"
      }
    ]
  },
  {
    "key": "txt_users_setup",
    "text": "Users Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعدادات المستخدم"
      },
      {
        "language": "FR",
        "text": "Configuration des Utilisateurs"
      },
      {
        "language": "DE",
        "text": "Benutzereinrichtung"
      },
      {
        "language": "IT",
        "text": "Configurazione degli utenti"
      }
    ]
  },
  {
    "key": "txt_new_users",
    "text": "New User",
    "translations": [
      {
        "language": "AR",
        "text": "مستخدم"
      },
      {
        "language": "FR",
        "text": "Nouvel Utilisateur"
      },
      {
        "language": "DE",
        "text": "Neuer Benutzer"
      },
      {
        "language": "IT",
        "text": "Nuovo utente"
      }
    ]
  },
  {
    "key": "txt_user_firstName",
    "text": "First Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم الأول"
      },
      {
        "language": "FR",
        "text": "Prénom"
      },
      {
        "language": "DE",
        "text": "Vorname"
      },
      {
        "language": "IT",
        "text": "Nome"
      }
    ]
  },
  {
    "key": "txt_user_lastName",
    "text": "Last Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم الأخير"
      },
      {
        "language": "FR",
        "text": "Nom de Famille"
      },
      {
        "language": "DE",
        "text": "Nachname"
      },
      {
        "language": "IT",
        "text": "Cognome"
      }
    ]
  },
  {
    "key": "txt_modal_user",
    "text": "New User",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستخدم "
      },
      {
        "language": "FR",
        "text": "Nouvel Utilisateur"
      },
      {
        "language": "DE",
        "text": "Neuer Benutzer"
      },
      {
        "language": "IT",
        "text": "Nuovo utente"
      }
    ]
  },
  {
    "key": "txt_is_super_user",
    "text": "Super User",
    "translations": [
      {
        "language": "AR",
        "text": "مستخدم متميز"
      },
      {
        "language": "FR",
        "text": "Super Utilisateur"
      },
      {
        "language": "DE",
        "text": "Super User"
      },
      {
        "language": "IT",
        "text": "Super utente"
      }
    ]
  },
  {
    "key": "txt_user_password",
    "text": "Password",
    "translations": [
      {
        "language": "AR",
        "text": "كلمة المرور"
      },
      {
        "language": "FR",
        "text": "Mot de Passe"
      },
      {
        "language": "DE",
        "text": "Passwort"
      },
      {
        "language": "IT",
        "text": "Password"
      }
    ]
  },
  {
    "key": "txt_user_companies",
    "text": "Organizations ",
    "translations": [
      {
        "language": "AR",
        "text": "المؤسسات"
      },
      {
        "language": "FR",
        "text": "Sociétés"
      },
      {
        "language": "DE",
        "text": " Organisationen"
      },
      {
        "language": "IT",
        "text": "Organizzazioni"
      }
    ]
  },
  {
    "key": "txt_content_languages",
    "text": "Supported Languages",
    "translations": [
      {
        "language": "AR",
        "text": "اللغات المدعومة"
      },
      {
        "language": "FR",
        "text": "Langages Supportés"
      },
      {
        "language": "DE",
        "text": "Unterstützte Sprachen"
      },
      {
        "language": "IT",
        "text": "Lingue supportate"
      }
    ]
  },
  {
    "key": "txt_company_structure",
    "text": "Organization Structure",
    "translations": [
      {
        "language": "AR",
        "text": "هيكل المؤسسة"
      },
      {
        "language": "FR",
        "text": "Structure de la société"
      },
      {
        "language": "DE",
        "text": "Organisationsstruktur"
      },
      {
        "language": "IT",
        "text": "Struttura organizzativa"
      }
    ]
  },
  {
    "key": "txt_structure_name",
    "text": "Entity Type",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الوحدة"
      },
      {
        "language": "FR",
        "text": "Type d’Unité"
      },
      {
        "language": "DE",
        "text": "Organisationstypus"
      },
      {
        "language": "IT",
        "text": "Tipo di livello organizzativo"
      }
    ]
  },
  {
    "key": "btn_structure_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": "Modifier "
      },
      {
        "language": "DE",
        "text": "Bearbeiten"
      },
      {
        "language": "IT",
        "text": "Modifica"
      }
    ]
  },
  {
    "key": "btn_structure_remove",
    "text": "Remove",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": "Supprimer"
      },
      {
        "language": "DE",
        "text": "Entfernen"
      },
      {
        "language": "IT",
        "text": "Rimuovi"
      }
    ]
  },
  {
    "key": "txt_structure_no_entities",
    "text": "No Entities found",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على أي وحدة"
      },
      {
        "language": "FR",
        "text": "Aucune Unité trouvée"
      },
      {
        "language": "DE",
        "text": "Keine Organisation gefunden"
      },
      {
        "language": "IT",
        "text": "Nessun livello organizzativo trovato"
      }
    ]
  },
  {
    "key": "btn_structure_new_entity",
    "text": "New Entity",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة وحدة"
      },
      {
        "language": "FR",
        "text": "Unité"
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_job_grade",
    "text": "Job Grade",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الوظيفية"
      },
      {
        "language": "FR",
        "text": "Catégorie d'Emploi"
      },
      {
        "language": "DE",
        "text": "Berufsgrad"
      },
      {
        "language": "IT",
        "text": "Categoria professionale"
      }
    ]
  },
  {
    "key": "txt_full_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      },
      {
        "language": "FR",
        "text": "Nom "
      },
      {
        "language": "DE",
        "text": "Name"
      },
      {
        "language": "IT",
        "text": "Nome"
      }
    ]
  },
  {
    "key": "txt_branches",
    "text": "Location / Branches",
    "translations": [
      {
        "language": "AR",
        "text": "الموقع / الفروع"
      },
      {
        "language": "FR",
        "text": "Emplacement / Succursales"
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txtWebsite",
    "text": "Website",
    "translations": [
      {
        "language": "AR",
        "text": "الموقع الإلكتروني"
      },
      {
        "language": "FR",
        "text": "Site Web "
      },
      {
        "language": "IT",
        "text": ""
      }
    ]
  },
  {
    "key": "txtWrongFormat",
    "text": "in wrong format",
    "translations": [
      {
        "language": "AR",
        "text": "الامتداد خطأ"
      },
      {
        "language": "FR",
        "text": "Dans un mauvais format"
      },
      {
        "language": "DE",
        "text": "falsches Format"
      },
      {
        "language": "IT",
        "text": "formato errato"
      }
    ]
  },
  {
    "key": "txtImageFormat",
    "text": "Logo needs to be PNG, JPEG, or GIF",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون الشعار بامتداد PNG أو JPEG أو GIF فقط"
      },
      {
        "language": "FR",
        "text": "Le Logo doit être au format PNG, JPEG ou GIF"
      },
      {
        "language": "DE",
        "text": "Das Logo muss im PNG-, JPEG- oder GIF-Format vorliegen."
      },
      {
        "language": "IT",
        "text": "Il logo deve essere in formato PNG, JPEG o GIF"
      }
    ]
  },
  {
    "key": "txt_fill_fields",
    "text": "Please, fill all required fields!",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة جميع الحقول المطلوبة!"
      },
      {
        "language": "DE",
        "text": "Bitte füllen Sie alle erforderlichen Felder aus!"
      },
      {
        "language": "IT",
        "text": "Compila tutti i campi obbligatori!"
      }
    ]
  },
  {
    "key": "txt_new_Company",
    "text": "New Organization",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مؤسسة"
      },
      {
        "language": "FR",
        "text": "Ajouter une Entreprise"
      },
      {
        "language": "DE",
        "text": "Neue Organisation"
      },
      {
        "language": "IT",
        "text": "Nuova organizzazione"
      }
    ]
  },
  {
    "key": "txt_inactive",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعال"
      },
      {
        "language": "FR",
        "text": "Inactif"
      },
      {
        "language": "DE",
        "text": "Inaktiv"
      },
      {
        "language": "IT",
        "text": "Inattivo"
      }
    ]
  },
  {
    "key": "txt_activate",
    "text": "Activate",
    "translations": [
      {
        "language": "AR",
        "text": "تفعيل"
      },
      {
        "language": "FR",
        "text": "Activer"
      },
      {
        "language": "DE",
        "text": "Aktivieren"
      },
      {
        "language": "IT",
        "text": "Attiva"
      }
    ]
  },
  {
    "key": "txt_deactivate",
    "text": "Deactivate",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء تفعيل"
      },
      {
        "language": "FR",
        "text": "Désactiver"
      },
      {
        "language": "DE",
        "text": "Deaktivieren"
      },
      {
        "language": "IT",
        "text": "Disattiva"
      }
    ]
  },
  {
    "key": "txtPerformance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      },
      {
        "language": "FR",
        "text": "Performance"
      },
      {
        "language": "BN",
        "text": "কর্মক্ষমতা"
      },
      {
        "language": "DE",
        "text": "Leistung"
      },
      {
        "language": "IT",
        "text": "Performance"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      },
      {
        "language": "DE",
        "text": "Stornieren"
      },
      {
        "language": "IT",
        "text": "Annulla"
      }
    ]
  },
  {
    "key": "Excel Integration",
    "text": "Excel Integration",
    "translations": [
      {
        "language": "AR",
        "text": "ترابط البيانات بواسطة Excel"
      },
      {
        "language": "DE",
        "text": "Excel-Integration"
      },
      {
        "language": "IT",
        "text": "Integrazione con Excel"
      }
    ]
  },
  {
    "key": "Fill out the premade template and share it with your Account Manager.",
    "text": "Fill out the premade template and share it with your Account Manager.",
    "translations": [
      {
        "language": "AR",
        "text": "املأ النموذج المعد مسبقاً وشاركه مع مدير حسابك"
      },
      {
        "language": "DE",
        "text": "Füllen Sie die vorgefertigte Vorlage aus und teilen Sie sie mit Ihrem Account Manager."
      },
      {
        "language": "IT",
        "text": "Compila il template predefinito e condividilo con il tuo Account Manager."
      }
    ]
  },
  {
    "key": "Click \"Download file\" to download the premade spreadsheet (.xlsx).",
    "text": "Click \"Download file\" to download the premade spreadsheet (.xlsx).",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على \"تحميل الملف\" لتحميل الجدول المعد مسبقاً (.xlsx)"
      },
      {
        "language": "DE",
        "text": "Klicken Sie auf „Datei herunterladen“, um die vorgefertigte Tabelle (.xlsx) herunterzuladen."
      },
      {
        "language": "IT",
        "text": "Clicca \"Scarica file\" per scaricare il file Excel predefinito (.xlsx)."
      }
    ]
  },
  {
    "key": "Harness the simplicity of integrating your data using Microsoft Excel",
    "text": "Harness the simplicity of integrating your data using Microsoft Excel",
    "translations": [
      {
        "language": "AR",
        "text": "قم بربط بياناتك بسهولة باستخدام Microsoft Excel"
      },
      {
        "language": "DE",
        "text": "Nutzen Sie die Einfachheit der Datenintegration mit Microsoft Excel"
      },
      {
        "language": "IT",
        "text": "Sfrutta la semplicità di integrare i tuoi dati con Microsoft Excel."
      }
    ]
  },
  {
    "key": "HAPPINESS",
    "text": "Employee Happiness",
    "translations": [
      {
        "language": "AR",
        "text": "سعادة الموظفين"
      },
      {
        "language": "DE",
        "text": "Mitarbeiterzufriedenheit"
      },
      {
        "language": "IT",
        "text": "Felicità dei dipendenti"
      }
    ]
  },
  {
    "key": "ENGAGEMENT",
    "text": "Employee Engagement",
    "translations": [
      {
        "language": "AR",
        "text": "اندماج الموظفين"
      },
      {
        "language": "DE",
        "text": "Mitarbeiterengagement"
      },
      {
        "language": "IT",
        "text": "Engagement dei dipendenti"
      }
    ]
  },
  {
    "key": "360",
    "text": "360° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "°تقييم 360"
      },
      {
        "language": "DE",
        "text": "360° Feedback"
      },
      {
        "language": "IT",
        "text": "Feedback 360°"
      }
    ]
  },
  {
    "key": "180",
    "text": "180° Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "°تقييم أداء 180 "
      },
      {
        "language": "FR",
        "text": "Évaluation du Commentaire ŕ 180°"
      },
      {
        "language": "DE",
        "text": "180° Feedback"
      },
      {
        "language": "IT",
        "text": "Feedback 180°"
      }
    ]
  },
  {
    "key": "EXIT",
    "text": "Employee Exit",
    "translations": [
      {
        "language": "AR",
        "text": "خروج الموظفين"
      },
      {
        "language": "DE",
        "text": "Mitarbeiter-Kündgung"
      },
      {
        "language": "IT",
        "text": "Employee Exit"
      }
    ]
  },
  {
    "key": "txt_companies",
    "text": "Organizations",
    "translations": [
      {
        "language": "AR",
        "text": "المؤسسات"
      },
      {
        "language": "FR",
        "text": "Sociétés"
      },
      {
        "language": "DE",
        "text": "Organisationen"
      },
      {
        "language": "IT",
        "text": "Organizzazioni"
      }
    ]
  },
  {
    "key": "txt_modal_company",
    "text": "New Organization ",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مؤسسة"
      },
      {
        "language": "FR",
        "text": "Ajouter une Entreprise"
      },
      {
        "language": "DE",
        "text": " Neue Organisation"
      },
      {
        "language": "IT",
        "text": "Nuova organizzazione"
      }
    ]
  },
  {
    "key": "txt_users",
    "text": "Users",
    "translations": [
      {
        "language": "AR",
        "text": "مستخدمين"
      },
      {
        "language": "FR",
        "text": "Utilisateurs"
      },
      {
        "language": "DE",
        "text": "Benutzer"
      },
      {
        "language": "IT",
        "text": "Utenti"
      }
    ]
  },
  {
    "key": "tenant_intro",
    "text": "Lets define your organizations: ",
    "translations": [
      {
        "language": "AR",
        "text": "عرّف المؤسسات الخاصة بك:"
      },
      {
        "language": "FR",
        "text": "Définissez vos entreprises: "
      },
      {
        "language": "DE",
        "text": " Definieren wir Ihre Organisationen:"
      },
      {
        "language": "IT",
        "text": "Imposta qui le tue organizzazioni:"
      }
    ]
  },
  {
    "key": "txtCompanySetup",
    "text": "Organization Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعدادات المؤسسة"
      },
      {
        "language": "FR",
        "text": "Configuration de la société"
      },
      {
        "language": "DE",
        "text": "Organisations-Setup"
      },
      {
        "language": "IT",
        "text": "Configurazione dell'organizzazione"
      }
    ]
  },
  {
    "key": "txtCreateCompany",
    "text": "Create Organization ",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء مؤسسة"
      },
      {
        "language": "FR",
        "text": "Créer une société"
      },
      {
        "language": "DE",
        "text": " Organisation erstellen"
      },
      {
        "language": "IT",
        "text": "Crea l'organizzazione"
      }
    ]
  },
  {
    "key": "txtWelcomeAboard",
    "text": "Welcome Aboard",
    "translations": [
      {
        "language": "AR",
        "text": "أهلا وسهلا بك معنا"
      },
      {
        "language": "FR",
        "text": "Bienvenue ŕ bord"
      },
      {
        "language": "DE",
        "text": "Willkommen an Bord"
      },
      {
        "language": "IT",
        "text": "Benvenuto a bordo"
      }
    ]
  },
  {
    "key": "txtwelcomedesc",
    "text": "Log in to Zenithr to continue",
    "translations": [
      {
        "language": "AR",
        "text": "للمتابعة، قم بتسجيل الدخول إلى زينثر"
      },
      {
        "language": "FR",
        "text": "Connectez-vous ŕ ZENITHR pour continuer"
      },
      {
        "language": "DE",
        "text": "Melden Sie sich bei Zenithr an, um fortzufahren"
      },
      {
        "language": "IT",
        "text": "Accedi a Zenithr per continuare"
      }
    ]
  },
  {
    "key": "txtResetyourpassword",
    "text": "Reset your password",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تعيين كلمة المرور"
      },
      {
        "language": "FR",
        "text": "Réinitialisez votre mot de passe"
      },
      {
        "language": "DE",
        "text": "Setzen Sie Ihr Passwort zurück"
      },
      {
        "language": "IT",
        "text": "Reimposta la tua password"
      }
    ]
  },
  {
    "key": "txtResetPassworddesc",
    "text": "You'll receive an email with further instructions",
    "translations": [
      {
        "language": "AR",
        "text": "سيصلك بريد إلكتروني بكامل الإرشادات"
      },
      {
        "language": "FR",
        "text": "Vous recevrez un email avec des instructions supplémentaires"
      },
      {
        "language": "DE",
        "text": "Sie erhalten eine E-Mail mit weiteren Anweisungen"
      },
      {
        "language": "IT",
        "text": "Riceverai un'email con ulteriori istruzioni"
      }
    ]
  },
  {
    "key": "txtUsername",
    "text": "Username",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المستخدم"
      },
      {
        "language": "FR",
        "text": "Nom d'utilisateur"
      },
      {
        "language": "BN",
        "text": "ব্যবহারকারীর নাম"
      },
      {
        "language": "DE",
        "text": "Benutzername"
      },
      {
        "language": "IT",
        "text": "Nome utente"
      }
    ]
  },
  {
    "key": "txtContinue",
    "text": "Continue",
    "translations": [
      {
        "language": "AR",
        "text": "استمر"
      },
      {
        "language": "FR",
        "text": "Continuer"
      },
      {
        "language": "HI",
        "text": "जारी रखें"
      },
      {
        "language": "TA",
        "text": "Magpatuloy"
      },
      {
        "language": "UR",
        "text": "جاری رکھیں"
      },
      {
        "language": "BN",
        "text": "অব্যাহত রাখুন"
      },
      {
        "language": "DE",
        "text": "Weiter"
      },
      {
        "language": "IT",
        "text": "Continua"
      }
    ]
  },
  {
    "key": "txtLogin",
    "text": "Log in",
    "translations": [
      {
        "language": "AR",
        "text": "تسجيل دخول"
      },
      {
        "language": "FR",
        "text": "Connecter"
      },
      {
        "language": "DE",
        "text": "Einloggen"
      },
      {
        "language": "IT",
        "text": "Accedi"
      }
    ]
  },
  {
    "key": "txtForgotYourPassword",
    "text": "Forgot Your Password?",
    "translations": [
      {
        "language": "AR",
        "text": "نسيت كلمة المرور؟"
      },
      {
        "language": "FR",
        "text": "Vous avez oublié votre mot de passe?"
      },
      {
        "language": "DE",
        "text": "Passwort vergessen?"
      },
      {
        "language": "IT",
        "text": "Password dimenticata?"
      }
    ]
  },
  {
    "key": "txtCheckyourEmail",
    "text": "Check your Email!",
    "translations": [
      {
        "language": "AR",
        "text": "تفقد بريدك الإلكتروني!"
      },
      {
        "language": "FR",
        "text": "Vérifiez votre Email!"
      },
      {
        "language": "DE",
        "text": "Prüfen Sie Ihre E-Mail!"
      },
      {
        "language": "IT",
        "text": "Controlla la tua email!"
      }
    ]
  },
  {
    "key": "txtCheckyourEmaildesc",
    "text": "An email with further instructions on how to set a new password has been sent to your inbox!",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال بريد إلكتروني يحتوي على خطوات تعيين كلمة مرور جديدة"
      },
      {
        "language": "FR",
        "text": "Un e-mail contenant des instructions supplémentaires sur la façon de définir un nouveau mot de passe a été envoyé dans votre boîte de réception!"
      },
      {
        "language": "DE",
        "text": "Eine E-Mail mit weiteren Anweisungen zum Festlegen eines neuen Passworts wurde an Ihren Posteingang gesendet!"
      },
      {
        "language": "IT",
        "text": "È stata inviata un'email alla tua casella di posta con ulteriori istruzioni per impostare una nuova password!"
      }
    ]
  },
  {
    "key": "txtBacktoLogin",
    "text": "Back to Log in",
    "translations": [
      {
        "language": "AR",
        "text": "العودة إلى تسجيل الدخول"
      },
      {
        "language": "FR",
        "text": "Retour ŕ se Connecter"
      },
      {
        "language": "DE",
        "text": "Zurück zur Anmeldung"
      },
      {
        "language": "IT",
        "text": "Torna al login"
      }
    ]
  },
  {
    "key": "Thomas International",
    "text": "Thomas International",
    "translations": [
      {
        "language": "AR",
        "text": "توماس العالمية"
      },
      {
        "language": "DE",
        "text": "Thomas International"
      },
      {
        "language": "IT",
        "text": "Thomas International"
      }
    ]
  },
  {
    "key": "TALENT ASSESSMENT",
    "text": "TALENT ASSESSMENT",
    "translations": [
      {
        "language": "AR",
        "text": "تقييم المواهب"
      },
      {
        "language": "DE",
        "text": "TALENT ASSESSMENT"
      },
      {
        "language": "IT",
        "text": "TALENT ASSESSMENT"
      }
    ]
  },
  {
    "key": "Harness the power of psychology and machine learning with the Thomas talent assessment platform. Make smarter recruitment and development decisions.",
    "text": "Harness the power of psychology and machine learning with the Thomas talent assessment platform. Make smarter recruitment and development decisions.",
    "translations": [
      {
        "language": "AR",
        "text": "استغل قوة علم النفس وتعلم الآلات مع منصة توماس لتقييم المواهب. اتخذ قرارات توظيف وتطوير أذكى."
      },
      {
        "language": "DE",
        "text": "Nutzen Sie die Möglichkeiten der Psychologie und des maschinellen Lernens mit der Talent-Assessment-Plattform von Thomas. Treffen Sie intelligentere Entscheidungen in den Bereichen Personalbeschaffung und -entwicklung."
      },
      {
        "language": "IT",
        "text": "Sfrutta la potenza della psicologia e della learning machine con la piattaforma di Talent Assessment di Thomas. Prendi decisioni più smart nell'ambito della selezione e dello sviluppo."
      }
    ]
  },
  {
    "key": "Test Connection",
    "text": "Test Connection",
    "translations": [
      {
        "language": "AR",
        "text": "حاول الاتصال"
      },
      {
        "language": "DE",
        "text": "Testverbindung"
      },
      {
        "language": "IT",
        "text": "Test di connessione"
      }
    ]
  },
  {
    "key": "Testing connection...",
    "text": "Testing connection...",
    "translations": [
      {
        "language": "AR",
        "text": "جاري محاولة الاتصال..."
      },
      {
        "language": "DE",
        "text": "Verbindung wird getestet..."
      },
      {
        "language": "IT",
        "text": "Test della connessione in corso..."
      }
    ]
  },
  {
    "key": "Starting user authentication",
    "text": "Starting user authentication",
    "translations": [
      {
        "language": "AR",
        "text": "البدء بمصادقة المستخدم"
      },
      {
        "language": "DE",
        "text": "Benutzerauthentifizierung starten"
      },
      {
        "language": "IT",
        "text": "Avvio dell'autenticazione utente"
      }
    ]
  },
  {
    "key": "User authenticated!",
    "text": "User authenticated!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت مصادقة المستخدم"
      },
      {
        "language": "DE",
        "text": "Benutzer authentifiziert!"
      },
      {
        "language": "IT",
        "text": "Utente autenticato!"
      }
    ]
  },
  {
    "key": "Connection established!",
    "text": "Connection established!",
    "translations": [
      {
        "language": "AR",
        "text": "تم الاتصال"
      },
      {
        "language": "DE",
        "text": "Verbindung hergestellt!"
      },
      {
        "language": "IT",
        "text": "Connessione stabilita!"
      }
    ]
  },
  {
    "key": "Connection Failed!",
    "text": "Connection Failed!",
    "translations": [
      {
        "language": "AR",
        "text": "فشل بالاتصال"
      },
      {
        "language": "DE",
        "text": "Verbindung fehlgeschlagen!"
      },
      {
        "language": "IT",
        "text": "Connessione fallita!"
      }
    ]
  },
  {
    "key": "INTEGRATE NOW",
    "text": "INTEGRATE NOW",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ بالترابط الآن"
      },
      {
        "language": "DE",
        "text": "JETZT INTEGRIEREN"
      },
      {
        "language": "IT",
        "text": "INTEGRA ORA"
      }
    ]
  },
  {
    "key": "Integrated",
    "text": "Integrated",
    "translations": [
      {
        "language": "AR",
        "text": "تم الترابط"
      },
      {
        "language": "DE",
        "text": "Integriert"
      },
      {
        "language": "IT",
        "text": "Integrato"
      }
    ]
  },
  {
    "key": "All registered companies",
    "text": "All registered organizations ",
    "translations": [
      {
        "language": "AR",
        "text": "جميع المؤسسات المسجلة"
      },
      {
        "language": "DE",
        "text": " Alle registrierten Organisationen"
      },
      {
        "language": "IT",
        "text": "Tutte le organizzazioni registrate"
      }
    ]
  },
  {
    "key": "assessment already in progress for this candidate",
    "text": "assessment already in progress for this candidate",
    "translations": [
      {
        "language": "AR",
        "text": "التقييم قيد التقدم بالفعل لهذا المرشح"
      },
      {
        "language": "DE",
        "text": "Für diesen Kandidaten läuft bereits eine Beurteilung"
      },
      {
        "language": "IT",
        "text": "Assessment già in corso per questo candidato"
      }
    ]
  }
]